<template>
  <div class="c1-main sc1-main c1-security-page" @click="c1TopTab = null">

    <!-- TOAST NOTIFICATION -->
    <transition name="sc1-toast-fade">
      <div v-if="sc1Toast" class="sc1-toast" :style="{ background: sc1Toast.color }">{{ sc1Toast.msg }}</div>
    </transition>

    <div class="c1-sticky-top">
    <!-- TOP BAR -->
    <div class="c1-tib" @click="c1SlideOpen = null">
      <div class="c1-tib-side c1-tib-left" style="padding-left:0;gap:8px;">
        <div class="c1-viki-topface"
          :class="{ 'c1-viki-topface--active': c1PanelActiveContent === 'viki' }"
          @click.stop="c1SelectPanel('viki','')"
        >
          <viki-face :mood="c1VikiMood" :speaking="c1VikiSpeaking" :size="44" style="width:72px;height:44px;display:block;overflow:hidden;border-radius:0;"/>
        </div>
        <div class="c1-shift-wrap" @click.stop="c1ShiftMenuOpen = !c1ShiftMenuOpen; c1HamMenuOpen = false">
          <div class="c1-tib-shift-pill" :class="{ open: c1ShiftMenuOpen }">
            ⏱ {{ c1ShiftElapsed }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;margin-left:3px;transition:transform .2s" :style="{ transform: c1ShiftMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>
      </div>
      <div class="c1-tib-center">
        <div class="c1-tib-mod-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          Security
        </div>
      </div>
      <div class="c1-tib-side c1-tib-right">
        <div class="c1-ham-wrap" @click.stop>
          <button class="c1-ham-btn" :class="{ open: c1HamMenuOpen }" @click="c1HamMenuOpen = !c1HamMenuOpen; c1ShiftMenuOpen = false">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </div>
    <!-- SHIFT DRAWER -->
    <div class="c1-top-drawer c1-shift-drawer" :class="{ open: c1ShiftMenuOpen }" @click.stop>
      <div class="c1-td-inner">
        <div class="c1-td-section-lbl">My Shift</div>
        <div class="c1-td-status-row">
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono">{{ c1ShiftStartTime ? new Date(c1ShiftStartTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—' }}</div>
            <div class="c1-td-stat-lbl">Started</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono" style="color:var(--c1-dp)">{{ c1ShiftElapsed }}</div>
            <div class="c1-td-stat-lbl">Elapsed</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1BathroomCount }}×</div>
            <div class="c1-td-stat-lbl">🚽 Bathroom</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1CoffeeCount }}×</div>
            <div class="c1-td-stat-lbl">☕ Coffee</div>
          </div>
        </div>
        <div class="c1-td-btn-row">
          <button class="c1-td-btn c1-td-btn-shift"   :class="{ active: c1Status === 'shift' }"   @click.stop="c1SetStatus('shift')">▶ On Shift</button>
          <button class="c1-td-btn c1-td-btn-bathroom" :class="{ active: c1Status === 'bathroom' }" @click.stop="c1SetStatus('bathroom')">🚽 Bathroom</button>
          <button class="c1-td-btn c1-td-btn-coffee"  :class="{ active: c1Status === 'coffee' }"  @click.stop="c1SetStatus('coffee')">☕ Coffee</button>
          <button class="c1-td-btn c1-td-btn-break"   :class="{ active: c1Status === 'break' }"   @click.stop="c1SetStatus('break')">⏸ Break</button>
          <button class="c1-td-btn c1-td-btn-lunch"   :class="{ active: c1Status === 'lunch' }"   @click.stop="c1SetStatus('lunch')">🍽 Lunch</button>
          <button class="c1-td-btn c1-td-btn-end"     @click.stop="c1SetStatus('end')">⏹ End Shift</button>
        </div>
      </div>
    </div>
    <!-- HAM NAV DRAWER -->
    <div class="c1-top-drawer c1-ham-drawer" :class="{ open: c1HamMenuOpen }" @click.stop>
      <div class="c1-td-inner c1-td-nav-grid">
        <router-link to="/clients1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-dp)"></span>Clients</router-link>
        <router-link to="/tasks1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-sc)"></span>Tasks</router-link>
        <router-link to="/stats1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-ld)"></span>Statistics</router-link>
        <router-link to="/chat1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-rf)"></span>Chat</router-link>
        <router-link to="/communications1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#3b82f6"></span>Communications</router-link>
        <router-link to="/affiliation1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#8b5cf6"></span>Affiliation</router-link>
        <router-link to="/finance1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#10b981"></span>Finance</router-link>
        <router-link to="/shifts1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#f59e0b"></span>Shifts</router-link>
        <router-link to="/users1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#06b6d4"></span>Users</router-link>
        <router-link to="/brokers1" class="c1-td-nav-item" :class="{ on: $route.path === '/brokers1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ec4899"></span>Brokers</router-link>
        <router-link to="/security1" class="c1-td-nav-item" :class="{ on: $route.path === '/security1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ef4444"></span>Security</router-link>
        <router-link to="/quiz1" class="c1-td-nav-item" :class="{ on: $route.path === '/quiz1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#a78bfa"></span>Quiz</router-link>
        <router-link to="/instruction1" class="c1-td-nav-item" :class="{ on: $route.path === '/instruction1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#64748b"></span>Instructions</router-link>
        <router-link to="/settings1" class="c1-td-nav-item" :class="{ on: $route.path === '/settings1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#94a3b8"></span>Settings</router-link>
        <router-link to="/profile1" class="c1-td-nav-item" :class="{ on: $route.path === '/profile1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#22d3ee"></span>My Profile</router-link>
      </div>
    </div>
    </div><!-- /c1-sticky-top -->

    <!-- TOP-STRIP TABS -->
    <div class="c1-ts-wrap" @click.stop>
      <!-- Event tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'event'}" @click.stop="c1TopTab = c1TopTab === 'event' ? null : 'event'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
        <span>Event</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='event' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>
      <!-- Risk tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'risk'}" @click.stop="c1TopTab = c1TopTab === 'risk' ? null : 'risk'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
        <span>Risk</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='risk' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>
      <!-- User tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'user'}" @click.stop="c1TopTab = c1TopTab === 'user' ? null : 'user'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
        <span>User</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='user' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>
      <!-- IP tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'ip'}" @click.stop="c1TopTab = c1TopTab === 'ip' ? null : 'ip'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
        <span>IP</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='ip' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>
      <!-- Date tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'date'}" @click.stop="c1TopTab = c1TopTab === 'date' ? null : 'date'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
        <span>Date</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='date' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>
      <!-- Charts tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'charts'}" @click.stop="c1TopTab = c1TopTab === 'charts' ? null : 'charts'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
        <span>Charts</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='charts' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>
      <!-- Team tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'team'}" @click.stop="c1TopTab = c1TopTab === 'team' ? null : 'team'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
        <span>Team</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='team' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>

      <!-- Dropdowns -->
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'event'" class="c1-ts-dropdown" @click.stop>
          <div style="padding:10px 14px;">
            <div class="sc1-fp-chips">
              <div class="sc1-chip" :class="{ on: sc1Filters.type === 'all' }" @click="sc1SetFilter('type','all')">All</div>
              <div class="sc1-chip sc1-chip--login" :class="{ on: sc1Filters.type === 'login' }" @click="sc1SetFilter('type','login')">Login</div>
              <div class="sc1-chip sc1-chip--admin" :class="{ on: sc1Filters.type === 'admin' }" @click="sc1SetFilter('type','admin')">Admin Action</div>
              <div class="sc1-chip sc1-chip--block" :class="{ on: sc1Filters.type === 'ip_block' }" @click="sc1SetFilter('type','ip_block')">IP Block</div>
              <div class="sc1-chip sc1-chip--perm" :class="{ on: sc1Filters.type === 'permission' }" @click="sc1SetFilter('type','permission')">Permission</div>
              <div class="sc1-chip sc1-chip--api" :class="{ on: sc1Filters.type === 'api' }" @click="sc1SetFilter('type','api')">API</div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'risk'" class="c1-ts-dropdown" @click.stop>
          <div style="padding:10px 14px;">
            <div class="sc1-fp-chips">
              <div class="sc1-chip" :class="{ on: sc1Filters.risk === 'all' }" @click="sc1SetFilter('risk','all')">All</div>
              <div class="sc1-chip sc1-chip--low" :class="{ on: sc1Filters.risk === 'low' }" @click="sc1SetFilter('risk','low')">Low</div>
              <div class="sc1-chip sc1-chip--medium" :class="{ on: sc1Filters.risk === 'medium' }" @click="sc1SetFilter('risk','medium')">Medium</div>
              <div class="sc1-chip sc1-chip--high" :class="{ on: sc1Filters.risk === 'high' }" @click="sc1SetFilter('risk','high')">High</div>
              <div class="sc1-chip sc1-chip--critical" :class="{ on: sc1Filters.risk === 'critical' }" @click="sc1SetFilter('risk','critical')">Critical</div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'user'" class="c1-ts-dropdown" @click.stop>
          <div style="padding:10px 14px;">
            <div class="c1-fs-search-wrap">
              <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input class="c1-fp-sinput" v-model.trim="sc1Filters.search" placeholder="Username, email…" type="text" @input="sc1ApplyFilters" />
              <div v-if="sc1Filters.search" class="c1-fp-sclear" @click="sc1Filters.search = ''; sc1ApplyFilters()">
                <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'ip'" class="c1-ts-dropdown" @click.stop>
          <div style="padding:10px 14px;">
            <div class="c1-fs-search-wrap">
              <svg class="c1-fp-sico" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
              <input class="c1-fp-sinput" v-model.trim="sc1Filters.ip" placeholder="e.g. 192.168.1.1" type="text" @input="sc1ApplyFilters" />
              <div v-if="sc1Filters.ip" class="c1-fp-sclear" @click="sc1Filters.ip = ''; sc1ApplyFilters()">
                <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'date'" class="c1-ts-dropdown" @click.stop>
          <div style="padding:10px 14px;">
            <div class="sc1-fp-chips" style="flex-wrap:wrap;">
              <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'T' }" @click="sc1SetFilter('datePreset','T')">Today</div>
              <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'Y' }" @click="sc1SetFilter('datePreset','Y')">Yesterday</div>
              <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'TW' }" @click="sc1SetFilter('datePreset','TW')">This Week</div>
              <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'LW' }" @click="sc1SetFilter('datePreset','LW')">Last Week</div>
              <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'TM' }" @click="sc1SetFilter('datePreset','TM')">This Month</div>
              <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'LM' }" @click="sc1SetFilter('datePreset','LM')">Last Month</div>
              <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'ALL' }" @click="sc1SetFilter('datePreset','ALL')">All Time</div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'charts'" class="c1-ts-dropdown" @click.stop>
          <div style="padding:10px 14px;max-height:400px;overflow-y:auto;">
            <div class="sc1-kpi-row">
              <div class="sc1-kpi"><div class="sc1-kpi-val sc1-val-ok">{{ sc1KpiLoginOk }}</div><div class="sc1-kpi-lbl">Logins OK</div></div>
              <div class="sc1-kpi"><div class="sc1-kpi-val sc1-val-warn">{{ sc1KpiLoginFail }}</div><div class="sc1-kpi-lbl">Failed</div></div>
              <div class="sc1-kpi"><div class="sc1-kpi-val sc1-val-crit">{{ sc1KpiBlocked }}</div><div class="sc1-kpi-lbl">Blocked</div></div>
              <div class="sc1-kpi"><div class="sc1-kpi-val sc1-val-info">{{ sc1KpiApiCalls }}</div><div class="sc1-kpi-lbl">API Calls</div></div>
            </div>
            <div class="sc1-chart-card" style="margin-top:12px">
              <div class="sc1-chart-title">Risk Levels</div>
              <div class="sc1-hbar-list">
                <div class="sc1-hbar-row"><div class="sc1-hbar-lbl">Low</div><div class="sc1-hbar-track"><div class="sc1-hbar-fill sc1-hbar--low" :style="{ width: sc1RiskPct('low') + '%' }"></div></div><div class="sc1-hbar-num">{{ sc1RiskCount('low') }}</div></div>
                <div class="sc1-hbar-row"><div class="sc1-hbar-lbl">Medium</div><div class="sc1-hbar-track"><div class="sc1-hbar-fill sc1-hbar--medium" :style="{ width: sc1RiskPct('medium') + '%' }"></div></div><div class="sc1-hbar-num">{{ sc1RiskCount('medium') }}</div></div>
                <div class="sc1-hbar-row"><div class="sc1-hbar-lbl">High</div><div class="sc1-hbar-track"><div class="sc1-hbar-fill sc1-hbar--high" :style="{ width: sc1RiskPct('high') + '%' }"></div></div><div class="sc1-hbar-num">{{ sc1RiskCount('high') }}</div></div>
                <div class="sc1-hbar-row"><div class="sc1-hbar-lbl">Critical</div><div class="sc1-hbar-track"><div class="sc1-hbar-fill sc1-hbar--critical" :style="{ width: sc1RiskPct('critical') + '%' }"></div></div><div class="sc1-hbar-num">{{ sc1RiskCount('critical') }}</div></div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'team'" class="c1-ts-dropdown" @click.stop>
          <div style="padding:10px 14px;">
            <div class="sc1-fp-chips">
              <div class="sc1-chip" :class="{ on: sec1TeamFilter === null }" @click="sec1TeamFilter = null; sc1ApplyFilters()">All</div>
              <div
                v-for="team in sec1Teams"
                :key="team.id"
                class="sc1-chip"
                :class="{ on: sec1TeamFilter === team.id }"
                :style="sec1TeamFilter === team.id ? { background: team.color || '#7c5cfc', borderColor: team.color || '#7c5cfc' } : {}"
                @click="sec1TeamFilter = (sec1TeamFilter === team.id ? null : team.id); sc1ApplyFilters()"
              >
                <span v-if="team.emoji" style="margin-right:4px">{{ team.emoji }}</span>{{ team.name }}
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="c1-nm-div"></div>
      <c1-mod-calendar :items="sc1Events" dateField="created_at" itemLabel="events" style="flex-shrink:0" />
    </div>

    <!-- PANEL BACKDROP -->
    <transition name="c1-bd-fade">
      <div v-if="c1SlideOpen" class="c1-panel-backdrop" @click.stop="c1SlideOpen = null"></div>
    </transition>

    <!-- ===== UNIFIED PANEL ===== -->
    <div class="c1-panel" :class="{ 'c1-panel--open': c1PanelIsOpen }" @click.capture="c1FilterPanelClick">
      <div class="c1-panel-track" :class="{ 'at-content': c1PanelAtContent }">

        <!-- SCREEN 0: NAV -->
        <div class="c1-panel-screen">
          <!-- User strip -->
          <div class="c1-nav-user-strip">
            <div class="c1-nav-av">
              {{ c1UserInitials }}
              <span class="c1-nav-av-dot" :class="'c1-dst-' + c1Status"></span>
            </div>
            <div class="c1-nav-uinfo">
              <div class="c1-nav-uname">{{ c1UserFullName }}</div>
              <div class="c1-nav-urole">{{ c1RoleLabel }}</div>
            </div>
            <div class="c1-nav-status-wrap" @click.stop="c1StatusMenuOpen = !c1StatusMenuOpen">
              <div class="c1-nav-status-btn" :class="'c1-st-' + c1Status">
                <span class="c1-nav-status-sdot"></span>
                <span class="c1-nav-status-elapsed">{{ c1StatusElapsed }}</span>
              </div>
              <transition name="c1-sfade">
                <div v-if="c1StatusMenuOpen" class="c1-nav-status-menu">
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('available')"><span class="c1-nav-status-opt-dot c1-st-dot-available"></span>Available</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('bathroom')"><span class="c1-nav-status-opt-dot c1-st-dot-bathroom"></span>Bathroom</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('coffee')"><span class="c1-nav-status-opt-dot c1-st-dot-coffee"></span>Coffee break</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('shift')"><span class="c1-nav-status-opt-dot c1-st-dot-shift"></span>Start shift</div>
                  <div class="c1-nav-status-opt c1-sto-end" @click.stop="c1SetStatus('end')"><span class="c1-nav-status-opt-dot c1-st-dot-end"></span>End shift</div>
                </div>
              </transition>
            </div>
          </div>

          <!-- Timezone bar -->
          <div class="c1-nav-tz-bar">
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇬🇧</span><span class="c1-nav-tz-time">{{ c1TzUK }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇮🇱</span><span class="c1-nav-tz-time">{{ c1TzIL }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🏝</span><span class="c1-nav-tz-time">{{ c1TzCB }}</span></div>
          </div>

          <!-- ── NAVIGATE: all pages ── -->
          <div v-if="c1NavMode === 'navigate'" class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-back" @click.stop="c1NavMode = 'panels'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="15 18 9 12 15 6"/></svg>
              <span class="c1-psel-sub-lbl">{{ c1CurrentPageLabel }}</span>
            <span class="c1-nav-x-btn" @click.stop="c1SlideOpen = null"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px;display:block"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span></div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">CRM</div>
            <router-link class="c1-psel-sub" to="/clients1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Clients</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/tasks1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Tasks</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/stats1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Statistics</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/chat1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Chat</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/communications1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Communications</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/affiliation1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Affiliation</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Sales</div>
            <router-link class="c1-psel-sub" to="/finance1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Finance</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/shifts1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Shifts</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/games1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Games</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Team</div>
            <router-link class="c1-psel-sub" to="/users1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Users</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/brokers1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Brokers</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/security1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Security</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Admin</div>
            <router-link class="c1-psel-sub" to="/quiz1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Quiz</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/instruction1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Instructions</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/settings1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Settings</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/profile1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">My Profile</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
          </div>

          <!-- Panels mode -->
          <div v-else class="c1-sl-body" style="padding:6px 0 12px">
            <!-- Navigate row -->
            <div class="c1-psel-sub c1-psel-sub-navigate" @click.stop="c1NavMode = 'navigate'">
              <span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span>
              <span class="c1-psel-sub-lbl" style="font-weight:600;color:var(--c1-dp)">{{ c1CurrentPageLabel }}</span>
              <span class="c1-psel-sub-hint">Go to another page</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
              Filters
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'filters' }" @click.stop="c1SelectPanel('filters','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Security Filters</span>
              <span class="c1-psel-sub-hint">Event type, risk, date, IP</span>
              <svg v-if="c1PanelActiveContent === 'filters'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
              Analytics
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'charts' }" @click.stop="c1SelectPanel('charts','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Security Charts</span>
              <span class="c1-psel-sub-hint">KPIs, login trends, risk levels</span>
              <svg v-if="c1PanelActiveContent === 'charts'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Calendar
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'calendar' }" @click.stop="c1SelectPanel('calendar','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Security Calendar</span>
              <span class="c1-psel-sub-hint">Events by day</span>
              <svg v-if="c1PanelActiveContent === 'calendar'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
              Viki
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'viki' }" @click.stop="c1SelectPanel('viki','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Viki Alerts</span>
              <span class="c1-psel-sub-hint">AI security notifications</span>
              <svg v-if="c1PanelActiveContent === 'viki'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
              IP Management
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'ipwhitelist' }" @click.stop="c1SelectPanel('ipwhitelist','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">IP Whitelist</span>
              <span class="c1-psel-sub-hint">User allowed IPs</span>
              <svg v-if="c1PanelActiveContent === 'ipwhitelist'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
              Logs &amp; Access
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'syslogs' }" @click.stop="c1SelectPanel('syslogs',''); sec1LoadLogs()">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">System Logs</span>
              <span class="c1-psel-sub-hint">Server-side event log</span>
              <svg v-if="c1PanelActiveContent === 'syslogs'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'globalip' }" @click.stop="c1SelectPanel('globalip',''); sec1LoadIPs()">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Global IP Whitelist</span>
              <span class="c1-psel-sub-hint">Allowed IPs for all users</span>
              <svg v-if="c1PanelActiveContent === 'globalip'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </div><!-- end v-else panels -->
        </div>

        <!-- SCREEN 1: CONTENT -->
        <div class="c1-panel-screen">
          <div class="c1-panel-hdr-bar">
            <div class="c1-panel-back-btn" @click="c1SlideOpen = 'nav'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </div>
            <span class="c1-panel-hdr-ttl">{{ c1ActivePanelLabel }}</span>
            <div class="c1-panel-back-btn" @click="c1SlideOpen = null">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="c1-sl-body">

            <!-- ===== FILTERS CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'filters'">
              <span v-if="sc1ActiveFilterCount" class="c1-panel-hdr-count" style="display:block;padding:4px 14px 0">{{ sc1ActiveFilterCount }} active</span>
              <div class="c1-sl-body">

        <!-- Event Type chips -->
        <div class="sc1-fp-group">
          <div class="sc1-fp-lbl">Event Type</div>
          <div class="sc1-fp-chips">
            <div class="sc1-chip" :class="{ on: sc1Filters.type === 'all' }" @click="sc1SetFilter('type','all')">All</div>
            <div class="sc1-chip sc1-chip--login" :class="{ on: sc1Filters.type === 'login' }" @click="sc1SetFilter('type','login')">Login</div>
            <div class="sc1-chip sc1-chip--admin" :class="{ on: sc1Filters.type === 'admin' }" @click="sc1SetFilter('type','admin')">Admin Action</div>
            <div class="sc1-chip sc1-chip--block" :class="{ on: sc1Filters.type === 'ip_block' }" @click="sc1SetFilter('type','ip_block')">IP Block</div>
            <div class="sc1-chip sc1-chip--perm" :class="{ on: sc1Filters.type === 'permission' }" @click="sc1SetFilter('type','permission')">Permission</div>
            <div class="sc1-chip sc1-chip--api" :class="{ on: sc1Filters.type === 'api' }" @click="sc1SetFilter('type','api')">API</div>
          </div>
        </div>

        <!-- Risk Level -->
        <div class="sc1-fp-group">
          <div class="sc1-fp-lbl">Risk Level</div>
          <div class="sc1-fp-chips">
            <div class="sc1-chip" :class="{ on: sc1Filters.risk === 'all' }" @click="sc1SetFilter('risk','all')">All</div>
            <div class="sc1-chip sc1-chip--low" :class="{ on: sc1Filters.risk === 'low' }" @click="sc1SetFilter('risk','low')">Low</div>
            <div class="sc1-chip sc1-chip--medium" :class="{ on: sc1Filters.risk === 'medium' }" @click="sc1SetFilter('risk','medium')">Medium</div>
            <div class="sc1-chip sc1-chip--high" :class="{ on: sc1Filters.risk === 'high' }" @click="sc1SetFilter('risk','high')">High</div>
            <div class="sc1-chip sc1-chip--critical" :class="{ on: sc1Filters.risk === 'critical' }" @click="sc1SetFilter('risk','critical')">Critical</div>
          </div>
        </div>

        <!-- User Search -->
        <div class="sc1-fp-group">
          <div class="sc1-fp-lbl">User</div>
          <div class="c1-fs-search-wrap">
            <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input class="c1-fp-sinput" v-model.trim="sc1Filters.search" placeholder="Username, email…" type="text" @input="sc1ApplyFilters" />
            <div v-if="sc1Filters.search" class="c1-fp-sclear" @click="sc1Filters.search = ''; sc1ApplyFilters()">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
        </div>

        <!-- IP Address Filter -->
        <div class="sc1-fp-group">
          <div class="sc1-fp-lbl">IP Address</div>
          <div class="c1-fs-search-wrap">
            <svg class="c1-fp-sico" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
            <input class="c1-fp-sinput" v-model.trim="sc1Filters.ip" placeholder="e.g. 192.168.1.1" type="text" @input="sc1ApplyFilters" />
            <div v-if="sc1Filters.ip" class="c1-fp-sclear" @click="sc1Filters.ip = ''; sc1ApplyFilters()">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
        </div>

        <!-- Date Presets -->
        <div class="sc1-fp-group">
          <div class="sc1-fp-lbl">Date Range</div>
          <div class="sc1-fp-chips">
            <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'T' }" @click="sc1SetFilter('datePreset','T')">Today</div>
            <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'Y' }" @click="sc1SetFilter('datePreset','Y')">Yesterday</div>
            <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'TW' }" @click="sc1SetFilter('datePreset','TW')">This Week</div>
            <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'LW' }" @click="sc1SetFilter('datePreset','LW')">Last Week</div>
            <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'TM' }" @click="sc1SetFilter('datePreset','TM')">This Month</div>
            <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'LM' }" @click="sc1SetFilter('datePreset','LM')">Last Month</div>
            <div class="sc1-chip" :class="{ on: sc1Filters.datePreset === 'ALL' }" @click="sc1SetFilter('datePreset','ALL')">All Time</div>
          </div>
        </div>

        <!-- Reset bar -->
        <div v-if="sc1ActiveFilterCount" class="c1-reset-bar" @click="sc1ResetFilters">
          <svg viewBox="0 0 24 24" width="14" height="14"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
          Reset all filters
          <span class="c1-reset-bar-count">{{ sc1ActiveFilterCount }}</span>
        </div>

              </div>
            </template>

            <!-- ===== CHARTS CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'charts'">
              <div class="c1-sl-body">

        <!-- KPI row -->
        <div class="sc1-kpi-row">
          <div class="sc1-kpi">
            <div class="sc1-kpi-val sc1-val-ok">{{ sc1KpiLoginOk }}</div>
            <div class="sc1-kpi-lbl">Logins OK</div>
          </div>
          <div class="sc1-kpi">
            <div class="sc1-kpi-val sc1-val-warn">{{ sc1KpiLoginFail }}</div>
            <div class="sc1-kpi-lbl">Failed</div>
          </div>
          <div class="sc1-kpi">
            <div class="sc1-kpi-val sc1-val-crit">{{ sc1KpiBlocked }}</div>
            <div class="sc1-kpi-lbl">Blocked</div>
          </div>
          <div class="sc1-kpi">
            <div class="sc1-kpi-val sc1-val-info">{{ sc1KpiApiCalls }}</div>
            <div class="sc1-kpi-lbl">API Calls</div>
          </div>
        </div>

        <!-- Login attempts — bar chart last 7 days -->
        <div class="sc1-chart-card">
          <div class="sc1-chart-title">Login Attempts — Last 7 Days</div>
          <div class="sc1-bar-chart">
            <div
              v-for="(day, idx) in sc1BarChartData"
              :key="idx"
              class="sc1-bar-col"
            >
              <div class="sc1-bar-wrap">
                <div
                  class="sc1-bar sc1-bar--ok"
                  :style="{ height: sc1BarHeight(day.ok) + 'px' }"
                  :title="day.ok + ' successful'"
                ></div>
                <div
                  class="sc1-bar sc1-bar--fail"
                  :style="{ height: sc1BarHeight(day.fail) + 'px' }"
                  :title="day.fail + ' failed'"
                ></div>
              </div>
              <div class="sc1-bar-lbl">{{ day.label }}</div>
            </div>
          </div>
          <div class="sc1-bar-legend">
            <span class="sc1-leg-dot sc1-leg-ok"></span> Success
            <span class="sc1-leg-dot sc1-leg-fail"></span> Failed
          </div>
        </div>

        <!-- Event Types — donut SVG -->
        <div class="sc1-chart-card">
          <div class="sc1-chart-title">Event Types</div>
          <div class="sc1-donut-wrap">
            <svg viewBox="0 0 120 120" width="120" height="120">
              <circle cx="60" cy="60" r="50" fill="none" stroke="var(--c1-border)" stroke-width="20"/>
              <circle
                v-for="(seg, i) in sc1DonutSegments"
                :key="i"
                cx="60" cy="60" r="50"
                fill="none"
                :stroke="seg.color"
                stroke-width="20"
                :stroke-dasharray="seg.dash"
                :stroke-dashoffset="seg.offset"
                transform="rotate(-90 60 60)"
              />
            </svg>
            <div class="sc1-donut-legend">
              <div v-for="(seg, i) in sc1DonutSegments" :key="i" class="sc1-donut-leg-row">
                <span class="sc1-leg-dot" :style="{ background: seg.color }"></span>
                <span>{{ seg.label }}</span>
                <span class="sc1-donut-leg-val">{{ seg.count }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Risk Levels — horizontal bars -->
        <div class="sc1-chart-card">
          <div class="sc1-chart-title">Risk Levels</div>
          <div class="sc1-hbar-list">
            <div class="sc1-hbar-row">
              <div class="sc1-hbar-lbl">Low</div>
              <div class="sc1-hbar-track">
                <div class="sc1-hbar-fill sc1-hbar--low" :style="{ width: sc1RiskPct('low') + '%' }"></div>
              </div>
              <div class="sc1-hbar-num">{{ sc1RiskCount('low') }}</div>
            </div>
            <div class="sc1-hbar-row">
              <div class="sc1-hbar-lbl">Medium</div>
              <div class="sc1-hbar-track">
                <div class="sc1-hbar-fill sc1-hbar--medium" :style="{ width: sc1RiskPct('medium') + '%' }"></div>
              </div>
              <div class="sc1-hbar-num">{{ sc1RiskCount('medium') }}</div>
            </div>
            <div class="sc1-hbar-row">
              <div class="sc1-hbar-lbl">High</div>
              <div class="sc1-hbar-track">
                <div class="sc1-hbar-fill sc1-hbar--high" :style="{ width: sc1RiskPct('high') + '%' }"></div>
              </div>
              <div class="sc1-hbar-num">{{ sc1RiskCount('high') }}</div>
            </div>
            <div class="sc1-hbar-row">
              <div class="sc1-hbar-lbl">Critical</div>
              <div class="sc1-hbar-track">
                <div class="sc1-hbar-fill sc1-hbar--critical" :style="{ width: sc1RiskPct('critical') + '%' }"></div>
              </div>
              <div class="sc1-hbar-num">{{ sc1RiskCount('critical') }}</div>
            </div>
          </div>
        </div>

        <!-- Top Users by Activity -->
        <div class="sc1-chart-card">
          <div class="sc1-chart-title">Top Users by Activity Today</div>
          <div class="sc1-leaderboard">
            <div
              v-for="(item, idx) in sc1TopUsers"
              :key="idx"
              class="sc1-lb-row"
            >
              <span class="sc1-lb-rank">#{{ idx + 1 }}</span>
              <span class="sc1-lb-name">{{ item.name }}</span>
              <span class="sc1-lb-count">{{ item.count }} events</span>
            </div>
            <div v-if="!sc1TopUsers.length" class="sc1-empty-small">No activity data</div>
          </div>
        </div>

              </div>
            </template>

            <!-- ===== CALENDAR CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'calendar'">
              <div class="c1-sl-body">

        <!-- Month nav -->
        <div class="sc1-cal-nav">
          <button class="sc1-cal-nav-btn" @click="sc1PrevMonth">
            <svg viewBox="0 0 24 24" width="14" height="14"><polyline points="15 18 9 12 15 6"/></svg>
          </button>
          <div class="sc1-cal-month-lbl">{{ sc1CalendarMonthLabel }}</div>
          <button class="sc1-cal-nav-btn" @click="sc1NextMonth">
            <svg viewBox="0 0 24 24" width="14" height="14"><polyline points="9 18 15 12 9 6"/></svg>
          </button>
        </div>

        <!-- Day headers -->
        <div class="sc1-cal-grid">
          <div class="sc1-cal-dow" v-for="d in ['Su','Mo','Tu','We','Th','Fr','Sa']" :key="d">{{ d }}</div>
          <div
            v-for="(cell, idx) in sc1CalendarCells"
            :key="idx"
            class="sc1-cal-cell"
            :class="{
              'sc1-cal-cell--empty': !cell.day,
              'sc1-cal-cell--today': cell.isToday,
              'sc1-cal-cell--selected': sc1SelectedDay === cell.day && cell.day
            }"
            @click="cell.day && sc1SelectDay(cell.day)"
          >
            <span v-if="cell.day" class="sc1-cal-day-num">{{ cell.day }}</span>
            <div v-if="cell.day && sc1DayStatus(cell.day)" class="sc1-cal-dots">
              <span
                v-for="(dot, di) in sc1DayDots(cell.day)"
                :key="di"
                class="sc1-cal-dot"
                :style="{ background: dot }"
              ></span>
            </div>
          </div>
        </div>

        <!-- Selected day events -->
        <div v-if="sc1SelectedDay" class="sc1-cal-day-events">
          <div class="sc1-fp-lbl">Events on {{ sc1SelectedDayLabel }}</div>
          <div v-if="sc1SelectedDayEvents.length === 0" class="sc1-empty-small">No events on this day</div>
          <div
            v-for="ev in sc1SelectedDayEvents"
            :key="ev.id"
            class="sc1-cal-ev-row"
            @click="sc1OpenDetail(ev)"
          >
            <span class="sc1-risk-dot" :class="'sc1-risk--' + ev.risk"></span>
            <span class="sc1-cal-ev-time">{{ sc1FormatTime(ev.timestamp) }}</span>
            <span class="sc1-cal-ev-desc">{{ ev.action }}</span>
          </div>
        </div>

              </div>
            </template>

            <!-- ===== VIKI CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'viki'">
              <span v-if="sc1VikiAlerts.length" class="c1-panel-hdr-count" style="display:block;padding:4px 14px 0">{{ sc1VikiAlerts.length }} alerts</span>
              <div class="c1-sl-body">

        <div v-if="!sc1VikiAlerts.length" class="sc1-viki-empty">
          <svg viewBox="0 0 24 24" width="36" height="36"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          <div>No critical alerts right now</div>
        </div>

        <div
          v-for="alert in sc1VikiAlerts"
          :key="alert.id"
          class="sc1-viki-card"
          :class="'sc1-viki-card--' + alert.severity"
        >
          <div class="sc1-viki-card-top">
            <span class="sc1-viki-badge" :class="'sc1-badge--' + alert.severity">{{ alert.severity }}</span>
            <span class="sc1-viki-time">{{ sc1FormatRelative(alert.timestamp) }}</span>
          </div>
          <div class="sc1-viki-title">{{ alert.title }}</div>
          <div class="sc1-viki-body">{{ alert.body }}</div>
          <div class="sc1-viki-actions">
            <button class="sc1-btn sc1-btn--danger" @click="sc1InvestigateAlert(alert)">Investigate</button>
            <button class="sc1-btn sc1-btn--ghost" @click="sc1DismissAlert(alert.id)">Dismiss</button>
          </div>
        </div>

              </div>
            </template>

            <!-- ===== IP WHITELIST CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'ipwhitelist'">
              <div class="c1-sl-body">

                <!-- Add IP form -->
                <div class="sc1-ipw-add-section">
                  <div class="sc1-fp-lbl">Add User IP</div>
                  <div class="sc1-ipw-add-row">
                    <select class="sc1-input sc1-ipw-select" v-model="sc1IpwNewUserId">
                      <option :value="null" disabled>Select user…</option>
                      <option v-for="u in sc1IpwUserList" :key="u.id" :value="u.id">{{ u.name || (u.first_name + ' ' + (u.last_name || '')) }}</option>
                    </select>
                    <input class="sc1-input" v-model.trim="sc1IpwNewIp" placeholder="IP address e.g. 192.168.1.1" type="text" @keyup.enter="sc1IpwAddIp" />
                    <button class="sc1-btn sc1-btn--ok" @click="sc1IpwAddIp">
                      <svg viewBox="0 0 24 24" width="13" height="13"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                      Add IP
                    </button>
                  </div>
                </div>

                <!-- User IP table -->
                <div class="sc1-fp-lbl" style="margin-top:12px">User IP Whitelist ({{ sc1IpwEntries.length }})</div>
                <div v-if="sc1IpwLoading" class="sc1-empty-small">
                  <span class="sc1-loading-dot"></span> Loading…
                </div>
                <div v-else-if="!sc1IpwEntries.length" class="sc1-empty-small">No user IP entries</div>
                <div v-else class="sc1-ipw-table">
                  <div class="sc1-ipw-thead">
                    <div class="sc1-ipw-th sc1-ipw-col-user">User Name</div>
                    <div class="sc1-ipw-th sc1-ipw-col-ip">IP Address</div>
                    <div class="sc1-ipw-th sc1-ipw-col-date">Added Date</div>
                    <div class="sc1-ipw-th sc1-ipw-col-actions">Actions</div>
                  </div>
                  <div
                    v-for="(entry, idx) in sc1IpwEntries"
                    :key="idx"
                    class="sc1-ipw-row"
                  >
                    <div class="sc1-ipw-td sc1-ipw-col-user">{{ entry.user_name || 'Unknown' }}</div>
                    <div class="sc1-ipw-td sc1-ipw-col-ip sc1-mono">
                      <template v-if="sc1IpwEditIdx === idx">
                        <input class="sc1-input sc1-ipw-edit-input" v-model.trim="sc1IpwEditIp" @keyup.enter="sc1IpwSaveEdit(idx)" />
                      </template>
                      <template v-else>{{ entry.ip }}</template>
                    </div>
                    <div class="sc1-ipw-td sc1-ipw-col-date">{{ entry.added_date || '—' }}</div>
                    <div class="sc1-ipw-td sc1-ipw-col-actions">
                      <template v-if="sc1IpwEditIdx === idx">
                        <button class="sc1-btn sc1-btn--ok sc1-btn--sm" @click="sc1IpwSaveEdit(idx)">Save</button>
                        <button class="sc1-btn sc1-btn--ghost sc1-btn--sm" @click="sc1IpwCancelEdit">Cancel</button>
                      </template>
                      <template v-else>
                        <button class="sc1-btn sc1-btn--info sc1-btn--sm" @click="sc1IpwStartEdit(idx)">
                          <svg viewBox="0 0 24 24" width="11" height="11"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                          Edit
                        </button>
                        <button class="sc1-btn sc1-btn--danger sc1-btn--sm" @click="sc1IpwDeleteEntry(idx)">
                          <svg viewBox="0 0 24 24" width="11" height="11"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>
                          Del
                        </button>
                      </template>
                    </div>
                  </div>
                </div>

                <button class="sc1-btn sc1-btn--ghost" style="margin-top:10px" @click="sc1IpwFetch">
                  <svg viewBox="0 0 24 24" width="13" height="13"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
                  Refresh
                </button>

              </div>
            </template>

            <!-- ===== SYSTEM LOGS CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'syslogs'">
              <div class="sec1-logs-wrap">
                <div class="sec1-log-row sec1-log-hdr">
                  <span>Event</span><span>User</span><span>Status</span><span>Time</span>
                </div>
                <div v-for="log in sec1Logs" :key="log.id" class="sec1-log-row" :class="{ err: log.status && log.status.includes('EXCEPTION') }">
                  <span class="sec1-log-asset" :title="log.asset">{{ (log.asset || '').split(':').pop().slice(0,30) }}</span>
                  <span>{{ log.user_id || 'system' }}</span>
                  <span class="sec1-log-status">{{ log.status && log.status.includes('EXCEPTION') ? '❌' : '✅' }}</span>
                  <span class="sec1-log-time">{{ log.created_at ? log.created_at.slice(0,16).replace('T',' ') : '' }}</span>
                </div>
                <div v-if="!sec1Logs.length" class="sec1-empty">No log entries</div>
                <button v-if="sec1Logs.length >= 50" class="sec1-load-more" @click="sec1LoadLogs(sec1LogsPage + 1)">Load more</button>
              </div>
            </template>

            <!-- ===== GLOBAL IP WHITELIST CONTENT ===== -->
            <template v-if="c1PanelActiveContent === 'globalip'">
              <div class="sec1-ip-wrap">
                <div class="sec1-ip-add-row">
                  <input class="sec1-ip-input" v-model="sec1NewIp" placeholder="e.g. 192.168.1.1" @keyup.enter="sec1AddIp()" />
                  <button class="sec1-ip-add-btn" @click="sec1AddIp()" :disabled="!sec1NewIp.trim()">Add IP</button>
                </div>
                <div v-if="!sec1IPs.length" class="sec1-empty">No IPs whitelisted — all IPs allowed</div>
                <div v-for="ip in sec1IPs" :key="ip.id" class="sec1-ip-row">
                  <span class="sec1-ip-val">{{ ip.ip }}</span>
                  <span class="sec1-ip-date">Added {{ ip.created_at ? ip.created_at.slice(0,10) : '' }}</span>
                  <button class="sec1-ip-del" @click="sec1RemoveIp(ip)">&#x2715;</button>
                </div>
              </div>
            </template>

          </div>
        </div>

      </div>
    </div>

    <!-- ===== SLIDE RIGHT — Event Detail ===== -->
    <div class="sc1-slide sc1-slide--right" v-show="sc1DetailEvent">
      <div class="sc1-slide-hdr">
        <div class="sc1-slide-hdr-title">
          <svg viewBox="0 0 24 24" width="16" height="16"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          Event Detail
        </div>
        <button class="sc1-slide-close" @click="sc1CloseDetail">
          <svg viewBox="0 0 24 24" width="16" height="16"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>

      <div class="sc1-slide-body" v-if="sc1DetailEvent">

        <!-- Event header -->
        <div class="sc1-detail-hero">
          <div class="sc1-detail-type-chip" :class="'sc1-type--' + (sc1DetailEvent && sc1DetailEvent.type)">
            {{ sc1DetailEvent && sc1DetailEvent.typeLabel }}
          </div>
          <div class="sc1-detail-risk">
            <span class="sc1-risk-dot" :class="'sc1-risk--' + (sc1DetailEvent && sc1DetailEvent.risk)"></span>
            {{ sc1DetailEvent && sc1DetailEvent.risk }}
          </div>
        </div>

        <div class="sc1-detail-meta-grid">
          <div class="sc1-meta-row">
            <span class="sc1-meta-lbl">Timestamp</span>
            <span class="sc1-meta-val">{{ sc1DetailEvent && sc1FormatFull(sc1DetailEvent.timestamp) }}</span>
          </div>
          <div class="sc1-meta-row">
            <span class="sc1-meta-lbl">User</span>
            <span class="sc1-meta-val">{{ sc1DetailEvent && sc1DetailEvent.user }}</span>
          </div>
          <div class="sc1-meta-row">
            <span class="sc1-meta-lbl">IP Address</span>
            <span class="sc1-meta-val sc1-mono">{{ sc1DetailEvent && sc1DetailEvent.ip }}</span>
          </div>
          <div class="sc1-meta-row">
            <span class="sc1-meta-lbl">Action</span>
            <span class="sc1-meta-val">{{ sc1DetailEvent && sc1DetailEvent.action }}</span>
          </div>
          <div class="sc1-meta-row">
            <span class="sc1-meta-lbl">User Agent</span>
            <span class="sc1-meta-val sc1-mono sc1-small">{{ sc1DetailEvent && sc1DetailEvent.userAgent }}</span>
          </div>
          <div class="sc1-meta-row">
            <span class="sc1-meta-lbl">Location</span>
            <span class="sc1-meta-val">{{ sc1DetailEvent && sc1DetailEvent.geo }}</span>
          </div>
        </div>

        <!-- Related events -->
        <div class="sc1-detail-section-lbl">Related Events</div>
        <div class="sc1-related-list">
          <div
            v-for="rel in sc1RelatedEvents"
            :key="rel.id"
            class="sc1-related-row"
            @click="sc1OpenDetail(rel)"
          >
            <span class="sc1-risk-dot" :class="'sc1-risk--' + rel.risk"></span>
            <span class="sc1-related-time">{{ sc1FormatTime(rel.timestamp) }}</span>
            <span class="sc1-related-action">{{ rel.action }}</span>
          </div>
          <div v-if="!sc1RelatedEvents.length" class="sc1-empty-small">No related events</div>
        </div>

        <!-- User recent history -->
        <div class="sc1-detail-section-lbl">User Recent History</div>
        <div class="sc1-related-list">
          <div
            v-for="hist in sc1UserHistory"
            :key="hist.id"
            class="sc1-related-row"
          >
            <span class="sc1-risk-dot" :class="'sc1-risk--' + hist.risk"></span>
            <span class="sc1-related-time">{{ sc1FormatTime(hist.timestamp) }}</span>
            <span class="sc1-related-action">{{ hist.action }}</span>
          </div>
          <div v-if="!sc1UserHistory.length" class="sc1-empty-small">No history found</div>
        </div>

        <!-- Action buttons -->
        <div class="sc1-detail-actions">
          <button class="sc1-btn sc1-btn--danger" @click="sc1BlockIp(sc1DetailEvent && sc1DetailEvent.ip)">
            <svg viewBox="0 0 24 24" width="13" height="13"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
            Block IP
          </button>
          <button class="sc1-btn sc1-btn--warn" @click="sc1WarnUser(sc1DetailEvent && sc1DetailEvent.user)">
            <svg viewBox="0 0 24 24" width="13" height="13"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/></svg>
            Warn User
          </button>
          <button class="sc1-btn sc1-btn--info" @click="sc1FlagForReview(sc1DetailEvent && sc1DetailEvent.id)">
            <svg viewBox="0 0 24 24" width="13" height="13"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>
            Flag for Review
          </button>
          <button class="sc1-btn sc1-btn--ok" @click="sc1MarkSafe(sc1DetailEvent && sc1DetailEvent.id)">
            <svg viewBox="0 0 24 24" width="13" height="13"><polyline points="20 6 9 17 4 12"/></svg>
            Mark Safe
          </button>
        </div>

      </div>
    </div>

    <!-- ===== SLIDE LEFT — IP Allowlist Manager ===== -->
    <div class="sc1-slide sc1-slide--left" v-show="sc1ShowIpManager">
      <div class="sc1-slide-hdr">
        <div class="sc1-slide-hdr-title">
          <svg viewBox="0 0 24 24" width="16" height="16"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
          IP Allowlist
        </div>
        <button class="sc1-slide-close" @click="sc1ShowIpManager = false">
          <svg viewBox="0 0 24 24" width="16" height="16"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>

      <div class="sc1-slide-body">

        <!-- Add IP form -->
        <div class="sc1-ip-add-form" v-show="sc1ShowAddIp">
          <div class="sc1-fp-lbl">Add IP Address</div>
          <div class="sc1-ip-add-row">
            <input
              class="sc1-input"
              v-model.trim="sc1NewIp"
              placeholder="e.g. 203.0.113.0"
              type="text"
              @keyup.enter="sc1AddIp"
            />
            <input
              class="sc1-input"
              v-model.trim="sc1NewIpNote"
              placeholder="Note (optional)"
              type="text"
            />
            <div class="sc1-ip-add-btns">
              <button class="sc1-btn sc1-btn--ok" @click="sc1AddIp">Add</button>
              <button class="sc1-btn sc1-btn--ghost" @click="sc1ShowAddIp = false; sc1NewIp = ''; sc1NewIpNote = ''">Cancel</button>
            </div>
          </div>
        </div>

        <!-- Bulk import -->
        <div v-if="sc1ShowBulkImport" class="sc1-bulk-import">
          <div class="sc1-fp-lbl">Bulk Import IPs (one per line)</div>
          <textarea class="sc1-textarea" v-model="sc1BulkIpText" rows="6" placeholder="192.168.1.1&#10;10.0.0.1&#10;..."></textarea>
          <div class="sc1-ip-add-btns">
            <button class="sc1-btn sc1-btn--ok" @click="sc1BulkAddIps">Import</button>
            <button class="sc1-btn sc1-btn--ghost" @click="sc1ShowBulkImport = false; sc1BulkIpText = ''">Cancel</button>
          </div>
        </div>

        <div class="sc1-ip-toolbar">
          <button v-if="!sc1ShowAddIp" class="sc1-btn sc1-btn--info" @click="sc1ShowAddIp = true">
            <svg viewBox="0 0 24 24" width="13" height="13"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Add IP
          </button>
          <button v-if="!sc1ShowBulkImport" class="sc1-btn sc1-btn--ghost" @click="sc1ShowBulkImport = true">Bulk Import</button>
        </div>

        <!-- Allowed IPs list -->
        <div class="sc1-fp-lbl" style="margin-top:12px">Allowed IPs ({{ sc1AllowedIps.length }})</div>
        <div v-if="!sc1AllowedIps.length" class="sc1-empty-small">No IPs on allowlist</div>
        <div
          v-for="(ip, idx) in sc1AllowedIps"
          :key="idx"
          class="sc1-ip-row"
        >
          <svg viewBox="0 0 24 24" width="13" height="13"><polyline points="20 6 9 17 4 12"/></svg>
          <span class="sc1-ip-addr sc1-mono">{{ ip.address }}</span>
          <span class="sc1-ip-note">{{ ip.note }}</span>
          <button class="sc1-ip-remove" @click="sc1RemoveIp(idx)" title="Remove">
            <svg viewBox="0 0 24 24" width="12" height="12"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

      </div>
    </div>

    <!-- ===== MAIN CONTENT ===== -->
    <div class="sc1-content" :class="{ 'sc1-content--shifted': c1PanelIsOpen }">

      <!-- Toolbar row -->
      <div class="sc1-toolbar">
        <div class="sc1-toolbar-left">
          <span class="sc1-count-label">
            {{ sc1FilteredEvents.length }} event{{ sc1FilteredEvents.length !== 1 ? 's' : '' }}
          </span>
          <span v-if="sc1Loading" class="sc1-loading-dot"></span>
        </div>
        <div class="sc1-toolbar-right">
          <button class="sc1-btn sc1-btn--ghost" @click="sc1ShowIpManager = !sc1ShowIpManager">
            <svg viewBox="0 0 24 24" width="13" height="13"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
            IP Allowlist
          </button>
          <button class="sc1-btn sc1-btn--ghost" @click="sc1FetchEvents">
            <svg viewBox="0 0 24 24" width="13" height="13"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
            Refresh
          </button>
        </div>
      </div>

      <!-- Team summary banner -->
      <div v-if="sec1Teams.length" class="sec1-team-summary">
        <span v-for="team in sec1Teams" :key="team.id" class="sec1-team-pill">
          <span class="sec1-team-pill-dot" :style="{ background: team.color || '#7c5cfc' }"></span>
          <strong>{{ team.name }}:</strong>&nbsp;{{ sec1TeamEventCountToday(team.id) }} events today
        </span>
      </div>

      <!-- Event list -->
      <div v-if="!sc1FilteredEvents.length" class="sc1-empty-state">
        <svg viewBox="0 0 24 24" width="48" height="48"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
        <div class="sc1-empty-title">No events match your filters</div>
        <div class="sc1-empty-sub">Try adjusting or resetting your filters</div>
        <button class="sc1-btn sc1-btn--ghost" @click="sc1ResetFilters">Reset Filters</button>
      </div>

      <div class="sc1-event-list">
        <div
          v-for="ev in sc1FilteredEvents"
          :key="ev.id"
          class="c1-box sc1-event-row"
          :class="{ 'sc1-event-row--expanded': sc1ExpandedId === ev.id, 'sc1-event-row--critical': ev.risk === 'critical', 'sc1-event-row--high': ev.risk === 'high' }"
        >
          <!-- Collapsed row -->
          <div class="sc1-row-main" @click="sc1ToggleExpand(ev.id)">
            <div class="sc1-row-ts">{{ sc1FormatTime(ev.timestamp) }}</div>
            <div class="sc1-row-type">
              <span class="sc1-type-chip" :class="'sc1-type--' + ev.type">{{ ev.typeLabel }}</span>
            </div>
            <div class="sc1-row-user">
              <span v-if="sec1UserTeamColor(ev.user_id || ev.user)" class="sec1-user-team-dot" :style="{ background: sec1UserTeamColor(ev.user_id || ev.user) }" :title="sec1UserTeamName(ev.user_id || ev.user)"></span>
              {{ ev.user }}
            </div>
            <div class="sc1-row-ip sc1-mono">{{ ev.ip }}</div>
            <div class="sc1-row-action">{{ ev.action }}</div>
            <div class="sc1-row-risk">
              <span class="sc1-risk-dot" :class="'sc1-risk--' + ev.risk" :title="ev.risk"></span>
            </div>
            <div class="sc1-row-expand-icon">
              <svg viewBox="0 0 24 24" width="12" height="12" :class="{ 'sc1-icon--rotated': sc1ExpandedId === ev.id }"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>

          <!-- Expanded detail inline -->
          <div v-if="sc1ExpandedId === ev.id" class="sc1-row-expanded">
            <div class="sc1-expanded-meta">
              <div class="sc1-meta-row">
                <span class="sc1-meta-lbl">Full Timestamp</span>
                <span class="sc1-meta-val">{{ sc1FormatFull(ev.timestamp) }}</span>
              </div>
              <div class="sc1-meta-row">
                <span class="sc1-meta-lbl">User Agent</span>
                <span class="sc1-meta-val sc1-mono sc1-small">{{ ev.userAgent }}</span>
              </div>
              <div class="sc1-meta-row">
                <span class="sc1-meta-lbl">Geolocation</span>
                <span class="sc1-meta-val">{{ ev.geo }}</span>
              </div>
              <div class="sc1-meta-row">
                <span class="sc1-meta-lbl">Risk</span>
                <span class="sc1-meta-val">
                  <span class="sc1-risk-dot" :class="'sc1-risk--' + ev.risk"></span>
                  {{ ev.risk }}
                </span>
              </div>
            </div>
            <div class="sc1-expanded-actions">
              <button class="sc1-btn sc1-btn--danger sc1-btn--sm" @click.stop="sc1BlockIp(ev.ip)">Block IP</button>
              <button class="sc1-btn sc1-btn--warn sc1-btn--sm" @click.stop="sc1WarnUser(ev.user)">Warn User</button>
              <button class="sc1-btn sc1-btn--ok sc1-btn--sm" @click.stop="sc1MarkSafe(ev.id)">Mark as OK</button>
              <button class="sc1-btn sc1-btn--info sc1-btn--sm" @click.stop="sc1OpenDetail(ev)">Full Detail</button>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import VikiFace from "../../clients1.feature/VikiFace.vue";
import { mapState } from 'vuex';
import C1ModCalendar from '../../../components/C1ModCalendar.vue';

const API = '/api';

const MONTH_NAMES = ['January','February','March','April','May','June','July','August','September','October','November','December'];

const MOCK_EVENTS = [
  {
    id: 1,
    timestamp: new Date(Date.now() - 1000 * 60 * 3).toISOString(),
    type: 'login',
    typeLabel: 'Login',
    user: 'admin@gnm.com',
    ip: '192.168.1.10',
    action: 'Successful login from Chrome/Windows',
    risk: 'low',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 Chrome/120.0.0.0 Safari/537.36',
    geo: 'Tel Aviv, Israel'
  },
  {
    id: 2,
    timestamp: new Date(Date.now() - 1000 * 60 * 7).toISOString(),
    type: 'login',
    typeLabel: 'Login',
    user: 'unknown@hacker.ru',
    ip: '45.33.32.156',
    action: 'Failed login attempt — invalid password',
    risk: 'high',
    userAgent: 'python-requests/2.28.0',
    geo: 'Moscow, Russia'
  },
  {
    id: 3,
    timestamp: new Date(Date.now() - 1000 * 60 * 12).toISOString(),
    type: 'login',
    typeLabel: 'Login',
    user: 'unknown@hacker.ru',
    ip: '45.33.32.156',
    action: 'Failed login attempt — account locked after 5 tries',
    risk: 'critical',
    userAgent: 'python-requests/2.28.0',
    geo: 'Moscow, Russia'
  },
  {
    id: 4,
    timestamp: new Date(Date.now() - 1000 * 60 * 20).toISOString(),
    type: 'ip_block',
    typeLabel: 'IP Block',
    user: 'system',
    ip: '45.33.32.156',
    action: 'IP auto-blocked after repeated failed logins',
    risk: 'critical',
    userAgent: '-',
    geo: 'Moscow, Russia'
  },
  {
    id: 5,
    timestamp: new Date(Date.now() - 1000 * 60 * 35).toISOString(),
    type: 'admin',
    typeLabel: 'Admin Action',
    user: 'superadmin@gnm.com',
    ip: '10.0.0.5',
    action: 'User role changed: editor → admin for user_id 42',
    risk: 'medium',
    userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 Chrome/120.0.0.0',
    geo: 'Tel Aviv, Israel'
  },
  {
    id: 6,
    timestamp: new Date(Date.now() - 1000 * 60 * 58).toISOString(),
    type: 'permission',
    typeLabel: 'Permission',
    user: 'agent1@gnm.com',
    ip: '172.16.0.22',
    action: 'Permission denied: attempted to access /admin/reports',
    risk: 'medium',
    userAgent: 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 Chrome/119.0.0.0',
    geo: 'Haifa, Israel'
  },
  {
    id: 7,
    timestamp: new Date(Date.now() - 1000 * 60 * 90).toISOString(),
    type: 'api',
    typeLabel: 'API',
    user: 'api_key:gk_prod_abc123',
    ip: '203.0.113.50',
    action: 'API key used: GET /api/clients — 450 records returned',
    risk: 'low',
    userAgent: 'axios/1.3.0',
    geo: 'Frankfurt, Germany'
  },
  {
    id: 8,
    timestamp: new Date(Date.now() - 1000 * 60 * 120).toISOString(),
    type: 'admin',
    typeLabel: 'Admin Action',
    user: 'superadmin@gnm.com',
    ip: '10.0.0.5',
    action: 'Bulk delete: 12 inactive client records removed',
    risk: 'high',
    userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 Chrome/120.0.0.0',
    geo: 'Tel Aviv, Israel'
  },
  {
    id: 9,
    timestamp: new Date(Date.now() - 1000 * 60 * 180).toISOString(),
    type: 'login',
    typeLabel: 'Login',
    user: 'manager@gnm.com',
    ip: '192.168.1.30',
    action: 'Successful login from Firefox/macOS',
    risk: 'low',
    userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:120.0) Gecko/20100101 Firefox/120.0',
    geo: 'Tel Aviv, Israel'
  },
  {
    id: 10,
    timestamp: new Date(Date.now() - 1000 * 60 * 240).toISOString(),
    type: 'api',
    typeLabel: 'API',
    user: 'api_key:gk_test_xyz789',
    ip: '198.51.100.8',
    action: 'API key used from unknown origin — rate limit warning',
    risk: 'medium',
    userAgent: 'curl/7.88.1',
    geo: 'Amsterdam, Netherlands'
  },
  {
    id: 11,
    timestamp: new Date(Date.now() - 1000 * 60 * 300).toISOString(),
    type: 'permission',
    typeLabel: 'Permission',
    user: 'agent3@gnm.com',
    ip: '172.16.0.44',
    action: 'Permission denied: tried to export all client data',
    risk: 'high',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Firefox/120.0',
    geo: 'Jerusalem, Israel'
  },
  {
    id: 12,
    timestamp: new Date(Date.now() - 1000 * 60 * 360).toISOString(),
    type: 'login',
    typeLabel: 'Login',
    user: 'bot@spam.io',
    ip: '80.82.77.139',
    action: 'Credential stuffing attack detected — 28 attempts',
    risk: 'critical',
    userAgent: 'Go-http-client/1.1',
    geo: 'Netherlands'
  },
  {
    id: 13,
    timestamp: new Date(Date.now() - 1000 * 60 * 420).toISOString(),
    type: 'ip_block',
    typeLabel: 'IP Block',
    user: 'system',
    ip: '80.82.77.139',
    action: 'IP range 80.82.77.0/24 auto-blocked',
    risk: 'critical',
    userAgent: '-',
    geo: 'Netherlands'
  },
  {
    id: 14,
    timestamp: new Date(Date.now() - 1000 * 60 * 480).toISOString(),
    type: 'admin',
    typeLabel: 'Admin Action',
    user: 'superadmin@gnm.com',
    ip: '10.0.0.5',
    action: 'System config updated: session timeout set to 30 minutes',
    risk: 'low',
    userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 Chrome/120.0.0.0',
    geo: 'Tel Aviv, Israel'
  },
  {
    id: 15,
    timestamp: new Date(Date.now() - 1000 * 60 * 600).toISOString(),
    type: 'permission',
    typeLabel: 'Permission',
    user: 'agent2@gnm.com',
    ip: '172.16.0.33',
    action: 'Permission changed: read-only access granted to finance module',
    risk: 'low',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0.0.0',
    geo: 'Tel Aviv, Israel'
  }
];

export default {
  name: 'Security1Container',

  components: { VikiFace, C1ModCalendar },

  data: function () {
    return {
      c1Status: 'shift',
      c1StatusSince: 0,
      c1StatusElapsed: '00:00',
      c1StatusMenuOpen: false,
      _c1StatusInterval: null,
      c1HamMenuOpen: false,
      c1ShiftMenuOpen: false,
      c1ShiftElapsed: '00:00',
      c1ShiftStartTime: 0,
      c1BathroomCount: 0,
      c1CoffeeCount: 0,
      c1WeekLog: [],
      c1TopTab: null,
      c1NavMode: 'panels',
      c1VikiMood: 'neutral',
      c1VikiSpeaking: false,
      c1SlideOpen: null,
      c1PanelActiveContent: null,
      sc1ActivePanel: null,
      sc1Events: [],
      sc1AllowedIps: [
        { address: '10.0.0.0/8', note: 'Internal network' },
        { address: '192.168.1.0/24', note: 'Office LAN' },
        { address: '203.0.113.50', note: 'API integration server' }
      ],
      sc1Filters: {
        type: 'all',
        risk: 'all',
        search: '',
        datePreset: 'T',
        ip: ''
      },
      sc1ExpandedId: null,
      sc1DetailEvent: null,
      sc1ShowIpManager: false,
      sc1ShowAddIp: false,
      sc1ShowBulkImport: false,
      sc1NewIp: '',
      sc1NewIpNote: '',
      sc1BulkIpText: '',
      sc1Loading: false,
      sc1VikiUnread: false,
      sc1VikiAlerts: [],
      sc1Toast: null,
      sc1CalendarMonth: new Date().getMonth(),
      sc1CalendarYear: new Date().getFullYear(),
      sc1SelectedDay: null,
      sc1ToastTimer: null,
      // IP Whitelist Management
      sc1IpwEntries: [],
      sc1IpwUserList: [],
      sc1IpwLoading: false,
      sc1IpwNewUserId: null,
      sc1IpwNewIp: '',
      sc1IpwEditIdx: null,
      sc1IpwEditIp: '',

      // ── System Logs ───────────────────────────────
      sec1Logs: [],
      sec1LogsPage: 1,

      // ── Global IP Whitelist ───────────────────────
      sec1IPs: [],
      sec1NewIp: '',

      // ── Team filter ───────────────────────────────
      sec1Teams: [],
      sec1TeamFilter: null,
    };
  },

  computed: Object.assign({},
    mapState('user', ['auth']),
    {
      c1CurrentPageLabel: function() {
        var map = {
          '/clients1':'Clients', '/tasks1':'Tasks', '/stats1':'Statistics',
          '/chat1':'Chat', '/communications1':'Communications', '/affiliation1':'Affiliation',
          '/finance1':'Finance', '/shifts1':'Shifts', '/games1':'Games',
          '/users1':'Users', '/brokers1':'Brokers', '/security1':'Security',
          '/quiz1':'Quiz', '/instruction1':'Instructions', '/settings1':'Settings', '/profile1':'My Profile',
        };
        return map[this.$route.path] || 'Menu';
      },
      c1UserInitials: function() {
        var u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
        if (!u) return "?";
        return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
      },
      c1UserFullName: function() {
        var u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
        if (!u) return "User";
        return [u.first_name, u.last_name].filter(Boolean).join(" ") || "User";
      },
      c1RoleLabel: function() {
        var u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
        if (!u) return "";
        var map = { admin: "Admin", manager: "Manager", agent: "Agent", broker: "Broker" };
        return map[u.role] || u.role || "";
      },
      c1TzUK: function() { return this.c1TzTime("Europe/London"); },
      c1TzIL: function() { return this.c1TzTime("Asia/Jerusalem"); },
      c1TzCB: function() { return this.c1TzTime("America/Cayman"); },

      c1PanelIsOpen: function () {
        return !!this.c1SlideOpen && this.c1SlideOpen !== 'menu';
      },

      c1PanelAtContent: function () {
        return this.c1PanelIsOpen && this.c1SlideOpen !== 'nav';
      },

      c1ActivePanelLabel: function () {
        if (!this.c1PanelIsOpen || this.c1SlideOpen === 'nav') return 'Panels';
        var map = { filters: 'Filters', charts: 'Charts', calendar: 'Calendar', viki: 'Viki', ipwhitelist: 'IP Whitelist', syslogs: 'System Logs', globalip: 'Global IP Whitelist' };
        return (this.c1PanelActiveContent && map[this.c1PanelActiveContent]) || 'Panels';
      },

      sc1UserName: function () {
        var auth = this.auth;
        if (auth && auth.user && auth.user.name) return auth.user.name;
        if (auth && auth.user && (auth.user.first_name || auth.user.last_name)) {
          return ((auth.user.first_name || '') + ' ' + (auth.user.last_name || '')).trim();
        }
        if (auth && auth.name) return auth.name;
        return 'Admin';
      },

      sc1Initials: function () {
        var name = this.sc1UserName;
        var parts = name.split(' ');
        if (parts.length >= 2) {
          return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
        }
        return name.charAt(0).toUpperCase();
      },

      sc1UserInitials: function () {
        var u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
        var n = (u && (u.first_name || u.username)) || 'A';
        return n.substring(0, 2).toUpperCase();
      },

      sc1AuthHeaders: function () {
        var token = localStorage.getItem('user-token');
        return { Authorization: 'Bearer ' + (token || '') };
      },

      sc1ActiveFilterCount: function () {
        var count = 0;
        var f = this.sc1Filters;
        if (f.type !== 'all') count++;
        if (f.risk !== 'all') count++;
        if (f.search) count++;
        if (f.datePreset !== 'T') count++;
        if (f.ip) count++;
        if (this.sec1TeamFilter !== null) count++;
        return count;
      },

      sc1FilteredEvents: function () {
        var self = this;
        var events = self.sc1Events;
        var f = self.sc1Filters;

        if (f.type !== 'all') {
          events = events.filter(function (ev) {
            return ev.type === f.type;
          });
        }

        if (f.risk !== 'all') {
          events = events.filter(function (ev) {
            return ev.risk === f.risk;
          });
        }

        if (f.search) {
          var s = f.search.toLowerCase();
          events = events.filter(function (ev) {
            var user = ev.user ? ev.user.toLowerCase() : '';
            var action = ev.action ? ev.action.toLowerCase() : '';
            var ip = ev.ip ? ev.ip.toLowerCase() : '';
            return user.indexOf(s) !== -1 || action.indexOf(s) !== -1 || ip.indexOf(s) !== -1;
          });
        }

        if (f.ip) {
          var ipSearch = f.ip.toLowerCase();
          events = events.filter(function (ev) {
            return ev.ip && ev.ip.toLowerCase().indexOf(ipSearch) !== -1;
          });
        }

        if (f.datePreset !== 'ALL') {
          var now = new Date();
          var cutoff = null;

          if (f.datePreset === 'T') {
            cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate());
          } else if (f.datePreset === 'Y') {
            var y = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            y.setDate(y.getDate() - 1);
            cutoff = y;
          } else if (f.datePreset === 'TW') {
            var tw = new Date(now);
            tw.setDate(tw.getDate() - tw.getDay());
            tw.setHours(0, 0, 0, 0);
            cutoff = tw;
          } else if (f.datePreset === 'LW') {
            var lw = new Date(now);
            lw.setDate(lw.getDate() - lw.getDay() - 7);
            lw.setHours(0, 0, 0, 0);
            cutoff = lw;
          } else if (f.datePreset === 'TM') {
            cutoff = new Date(now.getFullYear(), now.getMonth(), 1);
          } else if (f.datePreset === 'LM') {
            cutoff = new Date(now.getFullYear(), now.getMonth() - 1, 1);
          }

          if (cutoff) {
            events = events.filter(function (ev) {
              return new Date(ev.timestamp) >= cutoff;
            });
          }
        }

        // Team filter (client-side: match user_id against cached team members)
        if (this.sec1TeamFilter !== null) {
          var self2 = this;
          var teamId = self2.sec1TeamFilter;
          var teamObj = self2.sec1Teams.find(function (t) { return t.id === teamId; });
          if (teamObj && teamObj.members && teamObj.members.length) {
            var memberIds = teamObj.members.map(function (m) { return String(m.id || m.user_id); });
            events = events.filter(function (ev) {
              return memberIds.indexOf(String(ev.user_id)) !== -1;
            });
          }
        }

        return events;
      },

      sc1RelatedEvents: function () {
        if (!this.sc1DetailEvent) return [];
        var detail = this.sc1DetailEvent;
        return this.sc1Events.filter(function (ev) {
          return ev.id !== detail.id && (ev.ip === detail.ip || ev.user === detail.user);
        }).slice(0, 5);
      },

      sc1UserHistory: function () {
        if (!this.sc1DetailEvent) return [];
        var detail = this.sc1DetailEvent;
        return this.sc1Events.filter(function (ev) {
          return ev.user === detail.user && ev.id !== detail.id;
        }).slice(0, 8);
      },

      sc1BarChartData: function () {
        var days = [];
        var now = new Date();
        for (var i = 6; i >= 0; i--) {
          var d = new Date(now);
          d.setDate(d.getDate() - i);
          var dayStart = new Date(d.getFullYear(), d.getMonth(), d.getDate());
          var dayEnd = new Date(dayStart);
          dayEnd.setDate(dayEnd.getDate() + 1);
          var ok = 0;
          var fail = 0;
          this.sc1Events.forEach(function (ev) {
            var ts = new Date(ev.timestamp);
            if (ts >= dayStart && ts < dayEnd && ev.type === 'login') {
              if (ev.risk === 'low') ok++;
              else fail++;
            }
          });
          var labels = ['Su','Mo','Tu','We','Th','Fr','Sa'];
          days.push({ label: labels[d.getDay()], ok: ok, fail: fail });
        }
        return days;
      },

      sc1DonutSegments: function () {
        var events = this.sc1Events;
        var counts = { login: 0, admin: 0, ip_block: 0, permission: 0, api: 0 };
        events.forEach(function (ev) {
          if (counts[ev.type] !== undefined) counts[ev.type]++;
        });
        var total = events.length || 1;
        var colors = { login: '#4CAF50', admin: '#2196F3', ip_block: '#f44336', permission: '#FF9800', api: '#9C27B0' };
        var labels = { login: 'Login', admin: 'Admin', ip_block: 'IP Block', permission: 'Permission', api: 'API' };
        var circumference = 2 * Math.PI * 50;
        var segments = [];
        var cumulative = 0;
        var keys = Object.keys(counts);
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          var pct = counts[key] / total;
          var dash = pct * circumference;
          var gap = circumference - dash;
          var offset = -cumulative * circumference;
          segments.push({
            label: labels[key],
            count: counts[key],
            color: colors[key],
            dash: dash + ' ' + gap,
            offset: offset
          });
          cumulative += pct;
        }
        return segments;
      },

      sc1TopUsers: function () {
        var now = new Date();
        var todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var map = {};
        this.sc1Events.forEach(function (ev) {
          if (new Date(ev.timestamp) >= todayStart && ev.user) {
            if (!map[ev.user]) map[ev.user] = 0;
            map[ev.user]++;
          }
        });
        var arr = [];
        Object.keys(map).forEach(function (u) {
          arr.push({ name: u, count: map[u] });
        });
        arr.sort(function (a, b) { return b.count - a.count; });
        return arr.slice(0, 5);
      },

      sc1KpiLoginOk: function () {
        var now = new Date();
        var todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return this.sc1Events.filter(function (ev) {
          return ev.type === 'login' && ev.risk === 'low' && new Date(ev.timestamp) >= todayStart;
        }).length;
      },

      sc1KpiLoginFail: function () {
        var now = new Date();
        var todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return this.sc1Events.filter(function (ev) {
          return ev.type === 'login' && ev.risk !== 'low' && new Date(ev.timestamp) >= todayStart;
        }).length;
      },

      sc1KpiBlocked: function () {
        var now = new Date();
        var todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return this.sc1Events.filter(function (ev) {
          return ev.type === 'ip_block' && new Date(ev.timestamp) >= todayStart;
        }).length;
      },

      sc1KpiApiCalls: function () {
        var now = new Date();
        var todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return this.sc1Events.filter(function (ev) {
          return ev.type === 'api' && new Date(ev.timestamp) >= todayStart;
        }).length;
      },

      sc1CalendarMonthLabel: function () {
        return MONTH_NAMES[this.sc1CalendarMonth] + ' ' + this.sc1CalendarYear;
      },

      sc1CalendarCells: function () {
        var year = this.sc1CalendarYear;
        var month = this.sc1CalendarMonth;
        var firstDay = new Date(year, month, 1).getDay();
        var daysInMonth = new Date(year, month + 1, 0).getDate();
        var today = new Date();
        var cells = [];
        for (var i = 0; i < firstDay; i++) {
          cells.push({ day: null, isToday: false });
        }
        for (var d = 1; d <= daysInMonth; d++) {
          var isToday = (
            today.getFullYear() === year &&
            today.getMonth() === month &&
            today.getDate() === d
          );
          cells.push({ day: d, isToday: isToday });
        }
        return cells;
      },

      sc1SelectedDayEvents: function () {
        if (!this.sc1SelectedDay) return [];
        var year = this.sc1CalendarYear;
        var month = this.sc1CalendarMonth;
        var day = this.sc1SelectedDay;
        var dayStart = new Date(year, month, day);
        var dayEnd = new Date(year, month, day + 1);
        return this.sc1Events.filter(function (ev) {
          var ts = new Date(ev.timestamp);
          return ts >= dayStart && ts < dayEnd;
        });
      },

      sc1SelectedDayLabel: function () {
        if (!this.sc1SelectedDay) return '';
        return this.sc1SelectedDay + ' ' + MONTH_NAMES[this.sc1CalendarMonth] + ' ' + this.sc1CalendarYear;
      }
    }
  ),

  watch: {
    'c1SlideOpen': function (val) {
      if (val && val !== 'nav' && val !== 'menu') {
        this.c1PanelActiveContent = val;
        if (val === 'viki') {
          this.sc1VikiUnread = false;
        }
      }
    }
  },

  beforeDestroy() {
    if (this._c1StatusInterval) clearInterval(this._c1StatusInterval);
  },

  created() {
    if (sessionStorage.getItem('c1keepNav')) {
      sessionStorage.removeItem('c1keepNav');
      this.c1SlideOpen = 'nav';
      this.c1NavMode = 'panels';
    }
    sessionStorage.removeItem('c1openPanel');
  },

  mounted() {
    document.documentElement.style.setProperty('--gnm-sw', '0px');
    const savedStatus = localStorage.getItem('c1_status');
    const savedSince  = localStorage.getItem('c1_status_since');
    const today = new Date().toISOString().slice(0, 10);
    const savedShiftDay = localStorage.getItem('c1_shift_day');
    if (savedShiftDay !== today) {
      this.c1ShiftStartTime = Date.now();
      this.c1BathroomCount = 0;
      this.c1CoffeeCount = 0;
      localStorage.setItem('c1_status', 'shift');
      localStorage.setItem('c1_status_since', String(Date.now()));
      localStorage.setItem('c1_shift_start', String(Date.now()));
      localStorage.setItem('c1_shift_day', today);
      localStorage.setItem('c1_bathroom_count', '0');
      localStorage.setItem('c1_coffee_count', '0');
    } else {
      if (savedStatus) this.c1Status = savedStatus;
      this.c1ShiftStartTime = parseInt(localStorage.getItem('c1_shift_start') || String(Date.now()), 10);
      this.c1BathroomCount = parseInt(localStorage.getItem('c1_bathroom_count') || '0', 10);
      this.c1CoffeeCount   = parseInt(localStorage.getItem('c1_coffee_count') || '0', 10);
    }
    this.c1StatusSince = savedSince ? parseInt(savedSince, 10) : Date.now();
    this._c1StatusInterval = setInterval(this.c1TickStatus, 1000);
  },

  methods: {
    c1SetStatus(s) {
      if (s === 'bathroom') this.c1BathroomCount++;
      if (s === 'coffee')   this.c1CoffeeCount++;
      this.c1Status = s;
      this.c1StatusSince = Date.now();
      this.c1StatusElapsed = '00:00';
      this.c1ShiftMenuOpen = false;
      localStorage.setItem('c1_status', s);
      localStorage.setItem('c1_status_since', String(this.c1StatusSince));
      if (s === 'bathroom') localStorage.setItem('c1_bathroom_count', String(this.c1BathroomCount));
      if (s === 'coffee')   localStorage.setItem('c1_coffee_count',   String(this.c1CoffeeCount));
      if (s === 'end') this.c1SaveTodayToLog();
    },
    c1TickStatus() {
      const fmtSec = (sec) => {
        const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s2 = sec % 60;
        return h > 0
          ? String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0')
          : String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0');
      };
      this.c1StatusElapsed = fmtSec(Math.floor((Date.now() - this.c1StatusSince) / 1000));
      this.c1ShiftElapsed  = fmtSec(Math.floor((Date.now() - this.c1ShiftStartTime) / 1000));
    },
    c1SaveTodayToLog() {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const workedMin = Math.floor((Date.now() - this.c1ShiftStartTime) / 60000);
        const log = JSON.parse(localStorage.getItem('c1_week_log') || '[]').filter(r => r.date !== today);
        log.unshift({ date: today, workedMin: Math.max(0, workedMin), bathroom: this.c1BathroomCount, coffee: this.c1CoffeeCount });
        localStorage.setItem('c1_week_log', JSON.stringify(log.slice(0, 14)));
        this.c1WeekLog = log.slice(0, 14);
      } catch(e) {}
    },
    c1TzTime: function(tz) {
      try {
        return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz });
      } catch(e) { return "--:--"; }
    },
    c1Logout: function() {
      this.$store.dispatch('user/logOut');
    },

    c1PanelBtnClick: function () {
      this.c1SlideOpen = this.c1PanelIsOpen ? null : 'nav';
    },

    c1SelectPanel: function (panel) {
      this.c1SlideOpen = panel;
    },

    c1FilterPanelClick: function (e) {
      // Panel stays open after selecting a filter option — user uses back (←) or X to navigate/close
    },

    sc1TogglePanel: function (name) {
      if (this.sc1ActivePanel === name) {
        this.sc1ActivePanel = null;
      } else {
        this.sc1ActivePanel = name;
        if (name === 'viki') {
          this.sc1VikiUnread = false;
        }
      }
    },

    sc1SetFilter: function (key, val) {
      this.sc1Filters[key] = val;
      this.sc1ApplyFilters();
    },

    sc1ApplyFilters: function () {
      // Filters are applied reactively via computed sc1FilteredEvents
      // This method is a hook for any side effects needed
    },

    sc1ResetFilters: function () {
      this.sc1Filters = {
        type: 'all',
        risk: 'all',
        search: '',
        datePreset: 'T',
        ip: ''
      };
      this.sec1TeamFilter = null;
    },

    sc1ToggleExpand: function (id) {
      if (this.sc1ExpandedId === id) {
        this.sc1ExpandedId = null;
      } else {
        this.sc1ExpandedId = id;
      }
    },

    sc1OpenDetail: function (ev) {
      this.sc1DetailEvent = ev;
      this.c1SlideOpen = null;
    },

    sc1CloseDetail: function () {
      this.sc1DetailEvent = null;
    },

    sc1FetchEvents: function () {
      var self = this;
      self.sc1Loading = true;
      var url = API + '/admin/user/systemLog/1/50';
      fetch(url, { headers: self.sc1AuthHeaders })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          self.sc1Loading = false;
          var raw = (data && data.data) ? data.data : (Array.isArray(data) ? data : []);
          self.sc1Events = self.sc1NormalizeEvents(raw);
          self.sc1CheckVikiAlerts();
        })
        .catch(function () {
          self.sc1Loading = false;
          self.sc1Events = MOCK_EVENTS.slice();
          self.sc1CheckVikiAlerts();
        });
    },

    sc1FetchAllowedIps: function () {
      var self = this;
      var url = API + '/users/allowed_ip';
      fetch(url, { headers: self.sc1AuthHeaders })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var raw = (data && data.data) ? data.data : (Array.isArray(data) ? data : []);
          if (raw.length > 0) {
            self.sc1AllowedIps = raw.map(function (item) {
              return {
                address: (item && item.ip) ? item.ip : (item || ''),
                note: (item && item.note) ? item.note : ''
              };
            });
          }
        })
        .catch(function () {
          // keep default mock allowed IPs
        });
    },

    sc1NormalizeEvents: function (raw) {
      return raw.map(function (item, idx) {
        var typeMap = {
          login: 'Login',
          admin: 'Admin Action',
          ip_block: 'IP Block',
          permission: 'Permission',
          api: 'API'
        };
        var type = (item && item.event_type) ? item.event_type : 'login';
        return {
          id: (item && item.id) ? item.id : idx + 1,
          timestamp: (item && item.created_at) ? item.created_at : new Date().toISOString(),
          type: type,
          typeLabel: typeMap[type] || type,
          user: (item && item.username) ? item.username : ((item && item.user) ? item.user : 'unknown'),
          ip: (item && item.ip_address) ? item.ip_address : ((item && item.ip) ? item.ip : '0.0.0.0'),
          action: (item && item.description) ? item.description : ((item && item.action) ? item.action : 'Event recorded'),
          risk: (item && item.severity) ? item.severity : 'low',
          userAgent: (item && item.user_agent) ? item.user_agent : '-',
          geo: (item && item.geo) ? item.geo : 'Unknown'
        };
      });
    },

    sc1CheckVikiAlerts: function () {
      var critical = this.sc1Events.filter(function (ev) {
        return ev.risk === 'critical';
      });
      var self = this;
      var alerts = [];
      critical.forEach(function (ev) {
        alerts.push({
          id: 'viki-' + ev.id,
          severity: 'critical',
          title: ev.type === 'ip_block' ? 'IP Blocked: ' + ev.ip : 'Critical Security Event',
          body: ev.action,
          timestamp: ev.timestamp,
          eventId: ev.id
        });
      });
      var highCount = this.sc1Events.filter(function (ev) { return ev.risk === 'high'; }).length;
      if (highCount >= 3) {
        alerts.push({
          id: 'viki-high-cluster',
          severity: 'high',
          title: 'High Risk Cluster',
          body: highCount + ' high-risk events detected. Manual review recommended.',
          timestamp: new Date().toISOString(),
          eventId: null
        });
      }
      self.sc1VikiAlerts = alerts.slice(0, 10);
      if (alerts.length > 0) {
        self.sc1VikiUnread = true;
      }
    },

    sc1InvestigateAlert: function (alert) {
      if (alert.eventId) {
        var ev = null;
        for (var i = 0; i < this.sc1Events.length; i++) {
          if (this.sc1Events[i].id === alert.eventId) {
            ev = this.sc1Events[i];
            break;
          }
        }
        if (ev) {
          this.sc1OpenDetail(ev);
          this.c1SlideOpen = null;
        }
      }
    },

    sc1DismissAlert: function (alertId) {
      this.sc1VikiAlerts = this.sc1VikiAlerts.filter(function (a) {
        return a.id !== alertId;
      });
      if (this.sc1VikiAlerts.length === 0) {
        this.sc1VikiUnread = false;
      }
    },

    sc1BlockIp: function (ip) {
      if (!ip) return;
      var self = this;
      self.sc1ShowToast('IP ' + ip + ' has been blocked.', '#f44336');
      // Mark matching events
      self.sc1Events = self.sc1Events.map(function (ev) {
        if (ev.ip === ip) {
          return Object.assign({}, ev, { risk: 'critical' });
        }
        return ev;
      });
    },

    sc1WarnUser: function (user) {
      if (!user) return;
      this.sc1ShowToast('Warning issued to ' + user, '#FF9800');
    },

    sc1FlagForReview: function (id) {
      if (!id) return;
      this.sc1ShowToast('Event flagged for security review.', '#2196F3');
    },

    sc1MarkSafe: function (id) {
      if (!id) return;
      var self = this;
      self.sc1Events = self.sc1Events.map(function (ev) {
        if (ev.id === id) {
          return Object.assign({}, ev, { risk: 'low' });
        }
        return ev;
      });
      self.sc1ShowToast('Event marked as safe.', '#4CAF50');
      if (self.sc1DetailEvent && self.sc1DetailEvent.id === id) {
        self.sc1DetailEvent = Object.assign({}, self.sc1DetailEvent, { risk: 'low' });
      }
    },

    sc1AddIp: function () {
      var ip = this.sc1NewIp.trim();
      if (!ip) {
        this.sc1ShowToast('Please enter a valid IP address.', '#FF9800');
        return;
      }
      this.sc1AllowedIps.push({ address: ip, note: this.sc1NewIpNote.trim() });
      this.sc1NewIp = '';
      this.sc1NewIpNote = '';
      this.sc1ShowAddIp = false;
      this.sc1ShowToast('IP ' + ip + ' added to allowlist.', '#4CAF50');
    },

    sc1RemoveIp: function (idx) {
      var removed = this.sc1AllowedIps[idx];
      this.sc1AllowedIps.splice(idx, 1);
      this.sc1ShowToast('IP ' + (removed && removed.address) + ' removed from allowlist.', '#FF9800');
    },

    sc1BulkAddIps: function () {
      var lines = this.sc1BulkIpText.split('\n');
      var added = 0;
      var self = this;
      lines.forEach(function (line) {
        var ip = line.trim();
        if (ip) {
          self.sc1AllowedIps.push({ address: ip, note: 'Bulk import' });
          added++;
        }
      });
      this.sc1BulkIpText = '';
      this.sc1ShowBulkImport = false;
      this.sc1ShowToast(added + ' IPs imported to allowlist.', '#4CAF50');
    },

    // ── IP Whitelist Management ──
    sc1IpwFetch: function () {
      var self = this;
      self.sc1IpwLoading = true;
      var url = API + '/users/allowed_ip';
      fetch(url, { headers: self.sc1AuthHeaders })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          self.sc1IpwLoading = false;
          var raw = (data && data.data) ? data.data : (Array.isArray(data) ? data : []);
          self.sc1IpwEntries = raw.map(function (item) {
            return {
              id: item.id || null,
              user_id: item.user_id || null,
              user_name: item.user_name || item.username || (item.first_name ? item.first_name + ' ' + (item.last_name || '') : 'Unknown'),
              ip: item.ip || item.ip_address || item.address || '',
              added_date: item.created_at ? new Date(item.created_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : (item.added_date || '—')
            };
          });
        })
        .catch(function () {
          self.sc1IpwLoading = false;
          // Mock entries for development
          self.sc1IpwEntries = [
            { id: 1, user_id: 1, user_name: 'admin@gnm.com', ip: '10.0.0.0/8', added_date: '15 Jan 2026' },
            { id: 2, user_id: 2, user_name: 'superadmin@gnm.com', ip: '192.168.1.0/24', added_date: '20 Feb 2026' },
            { id: 3, user_id: 5, user_name: 'agent1@gnm.com', ip: '203.0.113.50', added_date: '01 Mar 2026' }
          ];
        });
    },

    sc1IpwFetchUsers: function () {
      var self = this;
      var url = API + '/users/table';
      fetch(url, { headers: self.sc1AuthHeaders })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var raw = (data && data.data) ? data.data : (Array.isArray(data) ? data : []);
          self.sc1IpwUserList = raw.map(function (u) {
            return {
              id: u.id,
              name: u.name || ((u.first_name || '') + ' ' + (u.last_name || '')).trim() || u.username || u.email || 'User #' + u.id
            };
          });
        })
        .catch(function () {
          self.sc1IpwUserList = [
            { id: 1, name: 'admin@gnm.com' },
            { id: 2, name: 'superadmin@gnm.com' },
            { id: 5, name: 'agent1@gnm.com' },
            { id: 7, name: 'manager@gnm.com' }
          ];
        });
    },

    sc1IpwAddIp: function () {
      var ip = this.sc1IpwNewIp.trim();
      if (!ip) {
        this.sc1ShowToast('Please enter a valid IP address.', '#FF9800');
        return;
      }
      if (!this.sc1IpwNewUserId) {
        this.sc1ShowToast('Please select a user.', '#FF9800');
        return;
      }
      var self = this;
      var userName = 'Unknown';
      for (var i = 0; i < self.sc1IpwUserList.length; i++) {
        if (self.sc1IpwUserList[i].id === self.sc1IpwNewUserId) {
          userName = self.sc1IpwUserList[i].name;
          break;
        }
      }
      var url = API + '/users/allowed_ip';
      fetch(url, {
        method: 'POST',
        headers: Object.assign({}, self.sc1AuthHeaders, { 'Content-Type': 'application/json' }),
        body: JSON.stringify({ user_id: self.sc1IpwNewUserId, ip: ip })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function () {
          self.sc1IpwEntries.push({
            id: Date.now(),
            user_id: self.sc1IpwNewUserId,
            user_name: userName,
            ip: ip,
            added_date: new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
          });
          self.sc1IpwNewIp = '';
          self.sc1IpwNewUserId = null;
          self.sc1ShowToast('IP ' + ip + ' added for ' + userName, '#4CAF50');
        })
        .catch(function () {
          // Optimistic add even if API fails
          self.sc1IpwEntries.push({
            id: Date.now(),
            user_id: self.sc1IpwNewUserId,
            user_name: userName,
            ip: ip,
            added_date: new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
          });
          self.sc1IpwNewIp = '';
          self.sc1IpwNewUserId = null;
          self.sc1ShowToast('IP ' + ip + ' added (local)', '#f59e0b');
        });
    },

    sc1IpwStartEdit: function (idx) {
      this.sc1IpwEditIdx = idx;
      this.sc1IpwEditIp = this.sc1IpwEntries[idx].ip;
    },

    sc1IpwCancelEdit: function () {
      this.sc1IpwEditIdx = null;
      this.sc1IpwEditIp = '';
    },

    sc1IpwSaveEdit: function (idx) {
      var ip = this.sc1IpwEditIp.trim();
      if (!ip) {
        this.sc1ShowToast('IP address cannot be empty.', '#FF9800');
        return;
      }
      var entry = this.sc1IpwEntries[idx];
      var self = this;
      // Attempt API update
      if (entry.id) {
        fetch(API + '/users/allowed_ip', {
          method: 'POST',
          headers: Object.assign({}, self.sc1AuthHeaders, { 'Content-Type': 'application/json' }),
          body: JSON.stringify({ id: entry.id, user_id: entry.user_id, ip: ip })
        }).catch(function () { /* silent fail */ });
      }
      entry.ip = ip;
      this.sc1IpwEditIdx = null;
      this.sc1IpwEditIp = '';
      this.sc1ShowToast('IP updated to ' + ip, '#4CAF50');
    },

    sc1IpwDeleteEntry: function (idx) {
      var entry = this.sc1IpwEntries[idx];
      var self = this;
      if (entry.id) {
        fetch(API + '/users/allowed_ip', {
          method: 'DELETE',
          headers: Object.assign({}, self.sc1AuthHeaders, { 'Content-Type': 'application/json' }),
          body: JSON.stringify({ id: entry.id })
        }).catch(function () { /* silent fail */ });
      }
      self.sc1IpwEntries.splice(idx, 1);
      self.sc1ShowToast('IP ' + entry.ip + ' removed for ' + entry.user_name, '#f44336');
    },

    sc1PrevMonth: function () {
      if (this.sc1CalendarMonth === 0) {
        this.sc1CalendarMonth = 11;
        this.sc1CalendarYear--;
      } else {
        this.sc1CalendarMonth--;
      }
      this.sc1SelectedDay = null;
    },

    sc1NextMonth: function () {
      if (this.sc1CalendarMonth === 11) {
        this.sc1CalendarMonth = 0;
        this.sc1CalendarYear++;
      } else {
        this.sc1CalendarMonth++;
      }
      this.sc1SelectedDay = null;
    },

    sc1SelectDay: function (day) {
      this.sc1SelectedDay = (this.sc1SelectedDay === day) ? null : day;
    },

    sc1DayStatus: function (day) {
      var year = this.sc1CalendarYear;
      var month = this.sc1CalendarMonth;
      var dayStart = new Date(year, month, day);
      var dayEnd = new Date(year, month, day + 1);
      for (var i = 0; i < this.sc1Events.length; i++) {
        var ts = new Date(this.sc1Events[i].timestamp);
        if (ts >= dayStart && ts < dayEnd) return true;
      }
      return false;
    },

    sc1DayDots: function (day) {
      var year = this.sc1CalendarYear;
      var month = this.sc1CalendarMonth;
      var dayStart = new Date(year, month, day);
      var dayEnd = new Date(year, month, day + 1);
      var hasCritical = false;
      var hasHigh = false;
      var hasLow = false;
      for (var i = 0; i < this.sc1Events.length; i++) {
        var ev = this.sc1Events[i];
        var ts = new Date(ev.timestamp);
        if (ts >= dayStart && ts < dayEnd) {
          if (ev.risk === 'critical') hasCritical = true;
          else if (ev.risk === 'high') hasHigh = true;
          else hasLow = true;
        }
      }
      var dots = [];
      if (hasCritical) dots.push('#f44336');
      if (hasHigh) dots.push('#FF9800');
      if (hasLow) dots.push('#4CAF50');
      return dots;
    },

    sc1BarHeight: function (val) {
      var max = 1;
      this.sc1BarChartData.forEach(function (d) {
        if (d.ok > max) max = d.ok;
        if (d.fail > max) max = d.fail;
      });
      return Math.max(2, Math.round((val / max) * 80));
    },

    sc1RiskCount: function (level) {
      return this.sc1Events.filter(function (ev) {
        return ev.risk === level;
      }).length;
    },

    sc1RiskPct: function (level) {
      var total = this.sc1Events.length;
      if (!total) return 0;
      return Math.round((this.sc1RiskCount(level) / total) * 100);
    },

    sc1FormatTime: function (ts) {
      if (!ts) return '-';
      var d = new Date(ts);
      var h = d.getHours();
      var m = d.getMinutes();
      return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
    },

    sc1FormatFull: function (ts) {
      if (!ts) return '-';
      var d = new Date(ts);
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
        ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
    },

    sc1FormatRelative: function (ts) {
      if (!ts) return '-';
      var now = new Date();
      var diff = Math.floor((now - new Date(ts)) / 1000);
      if (diff < 60) return diff + 's ago';
      if (diff < 3600) return Math.floor(diff / 60) + 'm ago';
      if (diff < 86400) return Math.floor(diff / 3600) + 'h ago';
      return Math.floor(diff / 86400) + 'd ago';
    },

    sc1ShowToast: function (msg, color) {
      var self = this;
      if (self.sc1ToastTimer) {
        clearTimeout(self.sc1ToastTimer);
      }
      self.sc1Toast = { msg: msg, color: color || 'var(--c1-accent)' };
      self.sc1ToastTimer = setTimeout(function () {
        self.sc1Toast = null;
        self.sc1ToastTimer = null;
      }, 3000);
    },

    // ── System Logs ───────────────────────────────
    sec1LoadLogs: function (page) {
      var self = this;
      if (!page) page = 1;
      self.sec1LogsPage = page;
      fetch(API + '/admin/user/systemLog?page=' + page + '&per_page=50', { headers: self.sc1AuthHeaders })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(function (data) {
          var rows = (data && data.data) ? data.data : (Array.isArray(data) ? data : []);
          if (page === 1) {
            self.sec1Logs = rows;
          } else {
            self.sec1Logs = self.sec1Logs.concat(rows);
          }
        })
        .catch(function () { /* silently fail — logs unavailable */ });
    },

    // ── Global IP Whitelist ───────────────────────
    sec1LoadIPs: function () {
      var self = this;
      fetch(API + '/users/allowed_ip', { headers: self.sc1AuthHeaders })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(function (data) {
          self.sec1IPs = (data && data.data) ? data.data : (Array.isArray(data) ? data : []);
        })
        .catch(function () { self.sec1IPs = []; });
    },

    sec1AddIp: function () {
      var self = this;
      var ip = self.sec1NewIp.trim();
      if (!ip) return;
      fetch(API + '/admin/allowed/ip/' + encodeURIComponent(ip), {
        method: 'POST',
        headers: self.sc1AuthHeaders
      })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(function () {
          self.sec1IPs.push({ id: Date.now(), ip: ip, created_at: new Date().toISOString() });
          self.sec1NewIp = '';
          self.sc1ShowToast('IP ' + ip + ' added to whitelist', '#4CAF50');
        })
        .catch(function (e) { self.sc1ShowToast('Failed to add IP: ' + (e.message || 'Error'), '#ef4444'); });
    },

    sec1RemoveIp: function (ipObj) {
      if (!confirm('Remove ' + ipObj.ip + ' from whitelist?')) return;
      var self = this;
      fetch(API + '/admin/allowed/ip/' + encodeURIComponent(ipObj.ip), {
        method: 'DELETE',
        headers: self.sc1AuthHeaders
      })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(function () {
          self.sec1IPs = self.sec1IPs.filter(function (i) { return i.id !== ipObj.id; });
          self.sc1ShowToast('IP ' + ipObj.ip + ' removed', '#f59e0b');
        })
        .catch(function () { self.sc1ShowToast('Failed to remove IP', '#ef4444'); });
    },

    // ── Team features ──────────────────────────────
    sec1FetchTeams: function () {
      var self = this;
      fetch(API + '/admin/teams', { headers: self.sc1AuthHeaders })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(function (data) {
          var raw = (data && data.data) ? data.data : (Array.isArray(data) ? data : []);
          self.sec1Teams = raw;
        })
        .catch(function () {
          // Silently fail — team filter chips just won't populate from API
        });
    },

    // Returns team_id for a given user_id by scanning sec1Teams members
    sec1UserTeam: function (userId) {
      if (!userId || !this.sec1Teams.length) return null;
      var uid = String(userId);
      for (var i = 0; i < this.sec1Teams.length; i++) {
        var team = this.sec1Teams[i];
        var members = team.members || [];
        for (var j = 0; j < members.length; j++) {
          var m = members[j];
          if (String(m.id || m.user_id) === uid) return team.id;
        }
      }
      return null;
    },

    sec1UserTeamColor: function (userId) {
      var teamId = this.sec1UserTeam(userId);
      if (!teamId) return null;
      var team = this.sec1Teams.find(function (t) { return t.id === teamId; });
      return team ? (team.color || '#7c5cfc') : null;
    },

    sec1UserTeamName: function (userId) {
      var teamId = this.sec1UserTeam(userId);
      if (!teamId) return '';
      var team = this.sec1Teams.find(function (t) { return t.id === teamId; });
      return team ? (team.name || '') : '';
    },

    sec1TeamEventCountToday: function (teamId) {
      var now = new Date();
      var todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var team = this.sec1Teams.find(function (t) { return t.id === teamId; });
      if (!team || !team.members) return 0;
      var memberIds = team.members.map(function (m) { return String(m.id || m.user_id); });
      return this.sc1Events.filter(function (ev) {
        return memberIds.indexOf(String(ev.user_id)) !== -1 && new Date(ev.timestamp) >= todayStart;
      }).length;
    },
  },

  mounted: function () {
    this.sc1FetchEvents();
    this.sc1FetchAllowedIps();
    this.sc1IpwFetch();
    this.sc1IpwFetchUsers();
    this.sec1FetchTeams();
  }
};
</script>

<style scoped>
/* ===== ROOT ===== */
.sc1-main {
  --c1-bg: #f4f3f0;
  --c1-surface: #ffffff;
  --c1-border: #e4e3df;
  --c1-accent: #7c5cfc;
  --c1-text: #1a1a1a;
  --c1-muted: #a09e98;
  --sc1-ok: #22c55e;
  --sc1-warn: #f59e0b;
  --sc1-high: #ef4444;
  --sc1-critical: #b91c1c;
  --sc1-info: #3b82f6;
  --sc1-api: #8b5cf6;
  --sc1-admin: #0891b2;
  --sc1-perm: #e05a3a;
  --sc1-block: #ef4444;
  background: var(--c1-bg);
  color: var(--c1-text);
  min-height: 100vh;
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 13px;
  position: relative;
}

/* ===== TOAST ===== */
.sc1-toast {
  position: fixed; bottom: 28px; left: 50%; transform: translateX(-50%);
  z-index: 99999; padding: 10px 22px; border-radius: 24px; color: #fff;
  font-size: .85rem; font-weight: 600; box-shadow: 0 4px 20px rgba(0,0,0,.25);
  pointer-events: none; white-space: nowrap; height: auto;
  display: inline-flex; align-items: center;
}
.sc1-toast-fade-enter-active, .sc1-toast-fade-leave-active { transition: opacity .25s, transform .25s; }
.sc1-toast-fade-enter, .sc1-toast-fade-leave-to { opacity: 0; transform: translateX(-50%) translateY(10px); }

/* ===== TOP BAR ===== */
.c1-tib {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 48px;
  padding: 0 12px;
  background: var(--c1-surface);
  border-bottom: 1px solid var(--c1-border);
  position: sticky;
  top: 0;
  z-index: 100;
}
.c1-tib-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.c1-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--c1-accent);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.c1-tib-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--c1-text);
}
.c1-hp {
  flex: 1;
}
.c1-tib-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  background: transparent;
  border: 1px solid var(--c1-border);
  border-radius: 6px;
  color: var(--c1-muted);
  font-size: 12px;
  cursor: pointer;
  position: relative;
  transition: color 0.15s, border-color 0.15s, background 0.15s;
}
.c1-tib-btn:hover { color: var(--c1-text); border-color: var(--c1-accent); }
.c1-tib-btn.active { color: var(--c1-accent); border-color: var(--c1-accent); background: rgba(79,142,247,0.08); }
.c1-tib-btn svg { stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.c1-tib-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--c1-accent);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
}
.c1-tib-user {
  padding: 6px 12px;
  color: var(--c1-muted);
  font-size: 12px;
  white-space: nowrap;
}
.c1-viki-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #f44336;
  position: absolute;
  top: 4px;
  right: 4px;
}

/* .c1-panel-backdrop — defined globally in c1-design.css */

/* .c1-panel positioning handled globally by c1-design.css */
.c1-panel-hdr-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--c1-border);
  flex-shrink: 0;
}
.c1-panel-hdr-bar svg { stroke: var(--c1-accent); fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.c1-panel-hdr-ttl { font-size: 13px; font-weight: 600; color: var(--c1-text); flex: 1; }
.c1-panel-hdr-count { font-size: 11px; color: var(--c1-accent); background: rgba(79,142,247,0.12); padding: 2px 7px; border-radius: 10px; }
.c1-collapse-btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  color: var(--c1-muted);
  transition: color 0.15s, background 0.15s;
}
.c1-collapse-btn:hover { color: var(--c1-text); background: rgba(255,255,255,0.05); }
.c1-collapse-btn svg { stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.c1-sl-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ===== RESET BAR ===== */
.c1-reset-bar {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 14px;
  background: rgba(244,67,54,0.08);
  border: 1px solid rgba(244,67,54,0.2);
  border-radius: 8px;
  color: #f44336;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.15s;
}
.c1-reset-bar:hover { background: rgba(244,67,54,0.15); }
.c1-reset-bar svg { stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.c1-reset-bar-count {
  margin-left: auto;
  background: #f44336;
  color: #fff;
  border-radius: 10px;
  padding: 1px 6px;
  font-size: 11px;
  font-weight: 700;
}

/* ===== FILTER PANEL INTERNALS ===== */
.sc1-fp-group { display: flex; flex-direction: column; gap: 8px; }
.sc1-fp-lbl { font-size: 11px; font-weight: 600; color: var(--c1-muted); text-transform: uppercase; letter-spacing: 0.06em; }
.sc1-fp-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.sc1-chip {
  padding: 5px 11px;
  border-radius: 20px;
  border: 1px solid var(--c1-border);
  color: var(--c1-muted);
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;
}
.sc1-chip:hover { color: var(--c1-text); border-color: var(--c1-accent); }
.sc1-chip.on { background: rgba(79,142,247,0.15); border-color: var(--c1-accent); color: var(--c1-accent); }
.sc1-chip--login.on { background: rgba(76,175,80,0.15); border-color: var(--sc1-ok); color: var(--sc1-ok); }
.sc1-chip--admin.on { background: rgba(0,188,212,0.15); border-color: var(--sc1-admin); color: var(--sc1-admin); }
.sc1-chip--block.on { background: rgba(244,67,54,0.15); border-color: var(--sc1-block); color: var(--sc1-block); }
.sc1-chip--perm.on { background: rgba(255,87,34,0.15); border-color: var(--sc1-perm); color: var(--sc1-perm); }
.sc1-chip--api.on { background: rgba(156,39,176,0.15); border-color: var(--sc1-api); color: var(--sc1-api); }
.sc1-chip--low.on { background: rgba(76,175,80,0.15); border-color: var(--sc1-ok); color: var(--sc1-ok); }
.sc1-chip--medium.on { background: rgba(255,152,0,0.15); border-color: var(--sc1-warn); color: var(--sc1-warn); }
.sc1-chip--high.on { background: rgba(244,67,54,0.15); border-color: var(--sc1-high); color: var(--sc1-high); }
.sc1-chip--critical.on { background: rgba(183,28,28,0.15); border-color: var(--sc1-critical); color: var(--sc1-critical); }

/* search wrap */
.c1-fs-search-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--c1-bg);
  border: 1px solid var(--c1-border);
  border-radius: 8px;
  padding: 0 10px;
}
.c1-fp-sico { stroke: var(--c1-muted); fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; width: 14px; height: 14px; flex-shrink: 0; }
.c1-fp-sinput { flex: 1; background: transparent; border: none; outline: none; color: var(--c1-text); font-size: 12px; padding: 8px 0; }
.c1-fp-sinput::placeholder { color: var(--c1-muted); }
.c1-fp-sclear { cursor: pointer; color: var(--c1-muted); display: flex; }
.c1-fp-sclear svg { stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; width: 14px; height: 14px; }

/* ===== CHARTS PANEL ===== */
.sc1-kpi-row { display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; gap: 8px; }
.sc1-kpi { background: var(--c1-bg); border: 1px solid var(--c1-border); border-radius: 8px; padding: 10px 8px; text-align: center; }
.sc1-kpi-val { font-size: 22px; font-weight: 700; line-height: 1; }
.sc1-kpi-lbl { font-size: 10px; color: var(--c1-muted); margin-top: 4px; }
.sc1-val-ok { color: var(--sc1-ok); }
.sc1-val-warn { color: var(--sc1-warn); }
.sc1-val-crit { color: var(--sc1-high); }
.sc1-val-info { color: var(--sc1-info); }

.sc1-chart-card { background: var(--c1-bg); border: 1px solid var(--c1-border); border-radius: 10px; padding: 14px; }
.sc1-chart-title { font-size: 12px; font-weight: 600; color: var(--c1-text); margin-bottom: 12px; }

/* bar chart */
.sc1-bar-chart { display: flex; gap: 6px; align-items: flex-end; height: 100px; }
.sc1-bar-col { display: flex; flex-direction: column; align-items: center; flex: 1; gap: 4px; }
.sc1-bar-wrap { display: flex; gap: 3px; align-items: flex-end; height: 88px; }
.sc1-bar { width: 8px; border-radius: 3px 3px 0 0; transition: height 0.3s; min-height: 2px; }
.sc1-bar--ok { background: var(--sc1-ok); }
.sc1-bar--fail { background: var(--sc1-high); }
.sc1-bar-lbl { font-size: 10px; color: var(--c1-muted); }
.sc1-bar-legend { display: flex; gap: 12px; margin-top: 8px; font-size: 11px; color: var(--c1-muted); align-items: center; }
.sc1-leg-dot { display: inline-block; width: 8px; height: 8px; border-radius: 2px; margin-right: 4px; }
.sc1-leg-ok { background: var(--sc1-ok); }
.sc1-leg-fail { background: var(--sc1-high); }

/* donut */
.sc1-donut-wrap { display: flex; gap: 16px; align-items: flex-start; }
.sc1-donut-legend { display: flex; flex-direction: column; gap: 6px; flex: 1; }
.sc1-donut-leg-row { display: flex; align-items: center; gap: 6px; font-size: 11px; color: var(--c1-muted); }
.sc1-donut-leg-val { margin-left: auto; color: var(--c1-text); font-weight: 600; }

/* horizontal bars */
.sc1-hbar-list { display: flex; flex-direction: column; gap: 8px; }
.sc1-hbar-row { display: flex; align-items: center; gap: 8px; }
.sc1-hbar-lbl { width: 60px; font-size: 11px; color: var(--c1-muted); flex-shrink: 0; }
.sc1-hbar-track { flex: 1; height: 8px; background: var(--c1-border); border-radius: 4px; overflow: hidden; }
.sc1-hbar-fill { height: 100%; border-radius: 4px; transition: width 0.4s; }
.sc1-hbar--low { background: var(--sc1-ok); }
.sc1-hbar--medium { background: var(--sc1-warn); }
.sc1-hbar--high { background: var(--sc1-high); }
.sc1-hbar--critical { background: var(--sc1-critical); }
.sc1-hbar-num { width: 28px; font-size: 11px; color: var(--c1-text); text-align: right; flex-shrink: 0; }

/* leaderboard */
.sc1-leaderboard { display: flex; flex-direction: column; gap: 6px; }
.sc1-lb-row { display: flex; align-items: center; gap: 8px; padding: 6px 8px; background: var(--c1-surface); border-radius: 6px; }
.sc1-lb-rank { font-size: 11px; color: var(--c1-muted); width: 20px; flex-shrink: 0; }
.sc1-lb-name { flex: 1; font-size: 12px; color: var(--c1-text); }
.sc1-lb-count { font-size: 11px; color: var(--sc1-info); }

/* ===== CALENDAR PANEL ===== */
.sc1-cal-nav { display: flex; align-items: center; justify-content: space-between; }
.sc1-cal-nav-btn { background: transparent; border: 1px solid var(--c1-border); border-radius: 6px; color: var(--c1-muted); cursor: pointer; padding: 5px 8px; display: flex; align-items: center; transition: color 0.15s; }
.sc1-cal-nav-btn:hover { color: var(--c1-text); }
.sc1-cal-nav-btn svg { stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.sc1-cal-month-lbl { font-size: 13px; font-weight: 600; color: var(--c1-text); }
.sc1-cal-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 3px; margin-top: 4px; }
.sc1-cal-dow { font-size: 10px; color: var(--c1-muted); text-align: center; padding: 4px 0; font-weight: 600; }
.sc1-cal-cell {
  min-height: 36px;
  border-radius: 6px;
  border: 1px solid transparent;
  padding: 3px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: background 0.15s, border-color 0.15s;
}
.sc1-cal-cell:hover { background: rgba(255,255,255,0.04); }
.sc1-cal-cell--empty { cursor: default; pointer-events: none; }
.sc1-cal-cell--today { border-color: var(--c1-accent); }
.sc1-cal-cell--selected { background: rgba(79,142,247,0.12); border-color: var(--c1-accent); }
.sc1-cal-day-num { font-size: 11px; color: var(--c1-text); }
.sc1-cal-dots { display: flex; gap: 2px; margin-top: 2px; }
.sc1-cal-dot { width: 5px; height: 5px; border-radius: 50%; }
.sc1-cal-day-events { margin-top: 12px; display: flex; flex-direction: column; gap: 6px; }
.sc1-cal-ev-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  background: var(--c1-bg);
  border: 1px solid var(--c1-border);
  border-radius: 7px;
  cursor: pointer;
  transition: border-color 0.15s;
}
.sc1-cal-ev-row:hover { border-color: var(--c1-accent); }
.sc1-cal-ev-time { font-size: 11px; color: var(--c1-muted); white-space: nowrap; }
.sc1-cal-ev-desc { font-size: 12px; color: var(--c1-text); flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

/* ===== VIKI PANEL ===== */
.sc1-viki-empty { display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 32px 0; color: var(--c1-muted); text-align: center; }
.sc1-viki-empty svg { stroke: var(--c1-muted); fill: none; stroke-width: 1.5; }
.sc1-viki-card { border-radius: 10px; border: 1px solid; padding: 12px 14px; display: flex; flex-direction: column; gap: 6px; }
.sc1-viki-card--critical { border-color: rgba(183,28,28,0.4); background: rgba(183,28,28,0.07); }
.sc1-viki-card--high { border-color: rgba(244,67,54,0.4); background: rgba(244,67,54,0.07); }
.sc1-viki-card--medium { border-color: rgba(255,152,0,0.4); background: rgba(255,152,0,0.07); }
.sc1-viki-card-top { display: flex; align-items: center; justify-content: space-between; }
.sc1-viki-badge { font-size: 10px; font-weight: 700; padding: 2px 8px; border-radius: 10px; text-transform: uppercase; }
.sc1-badge--critical { background: rgba(183,28,28,0.3); color: #ff5252; }
.sc1-badge--high { background: rgba(244,67,54,0.3); color: #ff6b6b; }
.sc1-badge--medium { background: rgba(255,152,0,0.3); color: #FFB74D; }
.sc1-viki-time { font-size: 11px; color: var(--c1-muted); }
.sc1-viki-title { font-size: 13px; font-weight: 600; color: var(--c1-text); }
.sc1-viki-body { font-size: 12px; color: var(--c1-muted); line-height: 1.4; }
.sc1-viki-actions { display: flex; gap: 8px; margin-top: 4px; }

/* ===== SLIDES ===== */
.sc1-slide {
  position: fixed;
  top: 48px;
  width: 380px;
  height: calc(100vh - 48px);
  background: var(--c1-surface);
  border: 1px solid var(--c1-border);
  z-index: 210;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.sc1-slide--right { right: 0; border-right: none; }
.sc1-slide--left { left: 0; border-left: none; }
.sc1-slide-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid var(--c1-border);
  flex-shrink: 0;
}
.sc1-slide-hdr-title { display: flex; align-items: center; gap: 8px; font-size: 14px; font-weight: 600; color: var(--c1-text); }
.sc1-slide-hdr-title svg { stroke: var(--c1-accent); fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.sc1-slide-close { background: transparent; border: 1px solid var(--c1-border); border-radius: 6px; color: var(--c1-muted); cursor: pointer; padding: 5px 8px; display: flex; align-items: center; }
.sc1-slide-close:hover { color: var(--c1-text); }
.sc1-slide-close svg { stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; }
.sc1-slide-body { flex: 1; overflow-y: auto; padding: 16px; display: flex; flex-direction: column; gap: 12px; }

/* detail */
.sc1-detail-hero { display: flex; align-items: center; gap: 10px; padding-bottom: 12px; border-bottom: 1px solid var(--c1-border); }
.sc1-detail-risk { display: flex; align-items: center; gap: 6px; font-size: 12px; color: var(--c1-text); text-transform: capitalize; }
.sc1-detail-meta-grid { display: flex; flex-direction: column; gap: 6px; }
.sc1-meta-row { display: flex; gap: 8px; font-size: 12px; }
.sc1-meta-lbl { color: var(--c1-muted); width: 90px; flex-shrink: 0; }
.sc1-meta-val { color: var(--c1-text); flex: 1; word-break: break-all; }
.sc1-detail-section-lbl { font-size: 11px; font-weight: 600; color: var(--c1-muted); text-transform: uppercase; letter-spacing: 0.06em; padding-top: 4px; }
.sc1-related-list { display: flex; flex-direction: column; gap: 4px; }
.sc1-related-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid var(--c1-border);
  cursor: pointer;
  transition: border-color 0.15s;
}
.sc1-related-row:hover { border-color: var(--c1-accent); }
.sc1-related-time { font-size: 11px; color: var(--c1-muted); white-space: nowrap; }
.sc1-related-action { font-size: 12px; color: var(--c1-text); flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sc1-detail-actions { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; padding-top: 8px; border-top: 1px solid var(--c1-border); }

/* IP manager */
.sc1-ip-add-form { background: var(--c1-bg); border: 1px solid var(--c1-border); border-radius: 8px; padding: 12px; display: flex; flex-direction: column; gap: 8px; }
.sc1-ip-add-row { display: flex; flex-direction: column; gap: 6px; }
.sc1-input {
  background: var(--c1-bg);
  border: 1px solid var(--c1-border);
  border-radius: 6px;
  padding: 8px 10px;
  color: var(--c1-text);
  font-size: 12px;
  outline: none;
  transition: border-color 0.15s;
}
.sc1-input:focus { border-color: var(--c1-accent); }
.sc1-textarea {
  background: var(--c1-bg);
  border: 1px solid var(--c1-border);
  border-radius: 6px;
  padding: 8px 10px;
  color: var(--c1-text);
  font-size: 12px;
  outline: none;
  resize: vertical;
  font-family: monospace;
  transition: border-color 0.15s;
}
.sc1-textarea:focus { border-color: var(--c1-accent); }
.sc1-ip-add-btns { display: flex; gap: 8px; }
.sc1-ip-toolbar { display: flex; gap: 8px; }
.sc1-ip-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  background: var(--c1-bg);
  border: 1px solid var(--c1-border);
  border-radius: 7px;
}
.sc1-ip-row svg { stroke: var(--sc1-ok); fill: none; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; flex-shrink: 0; }
.sc1-ip-addr { font-size: 12px; color: var(--c1-text); flex: 1; }
.sc1-ip-note { font-size: 11px; color: var(--c1-muted); }
.sc1-ip-remove {
  background: transparent;
  border: none;
  color: var(--c1-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 2px;
  border-radius: 4px;
  transition: color 0.15s;
}
.sc1-ip-remove:hover { color: var(--sc1-high); }
.sc1-ip-remove svg { stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; }
.sc1-bulk-import { background: var(--c1-bg); border: 1px solid var(--c1-border); border-radius: 8px; padding: 12px; display: flex; flex-direction: column; gap: 8px; }

/* ===== MAIN CONTENT ===== */
.sc1-content {
  padding: 16px;
  transition: margin-right 0.25s;
}
.sc1-content--shifted { margin-right: 320px; }
@media (max-width: 480px) {
  .sc1-content { padding: 8px; }
}

/* toolbar */
.sc1-toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.sc1-toolbar-left { display: flex; align-items: center; gap: 10px; }
.sc1-toolbar-right { display: flex; align-items: center; gap: 8px; }
.sc1-count-label { font-size: 12px; color: var(--c1-muted); }
.sc1-loading-dot { display: inline-block; width: 7px; height: 7px; border-radius: 50%; background: var(--c1-accent); animation: sc1pulse 1.2s infinite; }
@keyframes sc1pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.2; } }

/* event list */
.sc1-event-list { display: flex; flex-direction: column; gap: 4px; }

/* c1-box base */
.c1-box {
  background: var(--c1-surface);
  border: 1px solid var(--c1-border);
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.15s;
}
.c1-box:hover { border-color: rgba(79,142,247,0.3); }

.sc1-event-row--critical { border-left: 3px solid var(--sc1-critical); }
.sc1-event-row--high { border-left: 3px solid var(--sc1-high); }

.sc1-row-main {
  display: grid;
  grid-template-columns: 60px 110px 130px 110px 1fr 24px 20px;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.12s;
}
.sc1-row-main:hover { background: rgba(255,255,255,0.03); }

.sc1-row-ts { font-size: 11px; color: var(--c1-muted); white-space: nowrap; font-family: monospace; }
.sc1-row-type { }
.sc1-row-user { font-size: 12px; color: var(--c1-text); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sc1-row-ip { font-size: 11px; color: var(--c1-muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sc1-row-action { font-size: 12px; color: var(--c1-muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sc1-row-risk { display: flex; justify-content: center; }
.sc1-row-expand-icon { display: flex; justify-content: center; color: var(--c1-muted); }
.sc1-row-expand-icon svg { stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; transition: transform 0.2s; }
.sc1-icon--rotated { transform: rotate(180deg); }

/* type chips */
.sc1-type-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.sc1-type--login { background: rgba(76,175,80,0.15); color: var(--sc1-ok); }
.sc1-type--admin { background: rgba(0,188,212,0.15); color: var(--sc1-admin); }
.sc1-type--ip_block { background: rgba(244,67,54,0.15); color: var(--sc1-block); }
.sc1-type--permission { background: rgba(255,87,34,0.15); color: var(--sc1-perm); }
.sc1-type--api { background: rgba(156,39,176,0.15); color: var(--sc1-api); }

/* detail type chip in slide */
.sc1-detail-type-chip {
  display: inline-flex;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

/* risk dots */
.sc1-risk-dot { display: inline-block; width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.sc1-risk--low { background: var(--sc1-ok); }
.sc1-risk--medium { background: var(--sc1-warn); }
.sc1-risk--high { background: var(--sc1-high); }
.sc1-risk--critical { background: var(--sc1-critical); box-shadow: 0 0 6px var(--sc1-critical); }

/* expanded row */
.sc1-row-expanded {
  padding: 12px 14px 14px;
  border-top: 1px solid var(--c1-border);
  background: rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.sc1-expanded-meta { display: flex; flex-direction: column; gap: 5px; }
.sc1-expanded-actions { display: flex; gap: 8px; flex-wrap: wrap; }

/* ===== BUTTONS ===== */
.sc1-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 13px;
  border-radius: 7px;
  border: 1px solid;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.sc1-btn svg { stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.sc1-btn--sm { padding: 5px 10px; font-size: 11px; }
.sc1-btn--danger { background: rgba(244,67,54,0.1); border-color: rgba(244,67,54,0.4); color: #ef5350; }
.sc1-btn--danger:hover { background: rgba(244,67,54,0.2); }
.sc1-btn--warn { background: rgba(255,152,0,0.1); border-color: rgba(255,152,0,0.4); color: #FFA726; }
.sc1-btn--warn:hover { background: rgba(255,152,0,0.2); }
.sc1-btn--ok { background: rgba(76,175,80,0.1); border-color: rgba(76,175,80,0.4); color: #66BB6A; }
.sc1-btn--ok:hover { background: rgba(76,175,80,0.2); }
.sc1-btn--info { background: rgba(33,150,243,0.1); border-color: rgba(33,150,243,0.4); color: #42A5F5; }
.sc1-btn--info:hover { background: rgba(33,150,243,0.2); }
.sc1-btn--ghost { background: transparent; border-color: var(--c1-border); color: var(--c1-muted); }
.sc1-btn--ghost:hover { color: var(--c1-text); border-color: var(--c1-accent); }

/* ===== EMPTY STATES ===== */
.sc1-empty-state { display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 64px 24px; text-align: center; }
.sc1-empty-state svg { stroke: var(--c1-border); fill: none; stroke-width: 1.5; }
.sc1-empty-title { font-size: 15px; font-weight: 600; color: var(--c1-muted); }
.sc1-empty-sub { font-size: 12px; color: var(--c1-muted); opacity: 0.7; }
.sc1-empty-small { font-size: 12px; color: var(--c1-muted); padding: 8px 0; text-align: center; }

/* ===== IP WHITELIST TABLE ===== */
.sc1-ipw-add-section { background: var(--c1-bg); border: 1px solid var(--c1-border); border-radius: 8px; padding: 12px; display: flex; flex-direction: column; gap: 8px; }
.sc1-ipw-add-row { display: flex; flex-direction: column; gap: 6px; }
.sc1-ipw-select { background: var(--c1-bg); border: 1px solid var(--c1-border); border-radius: 6px; padding: 8px 10px; color: var(--c1-text); font-size: 12px; outline: none; transition: border-color 0.15s; appearance: none; cursor: pointer; }
.sc1-ipw-select:focus { border-color: var(--c1-accent); }
.sc1-ipw-table { display: flex; flex-direction: column; gap: 0; border: 1px solid var(--c1-border); border-radius: 8px; overflow: hidden; }
.sc1-ipw-thead { display: flex; background: var(--c1-bg); border-bottom: 1px solid var(--c1-border); }
.sc1-ipw-th { padding: 8px 10px; font-size: 10px; font-weight: 700; color: var(--c1-muted); text-transform: uppercase; letter-spacing: 0.06em; }
.sc1-ipw-row { display: flex; border-bottom: 1px solid var(--c1-border); transition: background 0.12s; }
.sc1-ipw-row:last-child { border-bottom: none; }
.sc1-ipw-row:hover { background: rgba(79,142,247,0.04); }
.sc1-ipw-td { padding: 8px 10px; font-size: 12px; color: var(--c1-text); display: flex; align-items: center; gap: 4px; }
.sc1-ipw-col-user { flex: 2; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.sc1-ipw-col-ip { flex: 2; min-width: 0; }
.sc1-ipw-col-date { flex: 1.5; min-width: 0; color: var(--c1-muted); font-size: 11px; }
.sc1-ipw-col-actions { flex: 1.5; min-width: 0; display: flex; gap: 4px; }
.sc1-ipw-edit-input { width: 100%; background: var(--c1-bg); border: 1px solid var(--c1-accent); border-radius: 4px; padding: 4px 6px; color: var(--c1-text); font-size: 12px; font-family: 'SFMono-Regular', Consolas, monospace; outline: none; }

/* ===== UTILITIES ===== */
.sc1-mono { font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace; }
.sc1-small { font-size: 10px; line-height: 1.4; }

/* ===== SYSTEM LOGS ===== */
.sec1-logs-wrap, .sec1-ip-wrap { padding: 8px 0; }
.sec1-log-row { display: grid; grid-template-columns: 2fr 1fr 60px 1fr; gap: 8px; padding: 8px 12px; border-bottom: 1px solid rgba(0,0,0,.06); font-size: 12px; align-items: center; }
.sec1-log-hdr { font-weight: 600; opacity: .5; font-size: 11px; border-bottom: 1px solid var(--c1-border) !important; }
.sec1-log-row.err { background: rgba(239,68,68,.04); }
.sec1-log-asset { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; opacity: .8; }
.sec1-log-time { opacity: .5; font-size: 11px; }
.sec1-log-status { text-align: center; }
.sec1-empty { opacity: .4; font-size: 13px; padding: 16px 12px; text-align: center; }
.sec1-load-more { margin: 10px auto; display: block; background: rgba(0,0,0,.05); border: 1px solid var(--c1-border); border-radius: 6px; padding: 6px 16px; font-size: 12px; cursor: pointer; color: var(--c1-text); }

/* ===== GLOBAL IP WHITELIST ===== */
.sec1-ip-add-row { display: flex; gap: 8px; padding: 0 12px 12px; }
.sec1-ip-input { flex: 1; background: var(--c1-surface); border: 1px solid var(--c1-border); border-radius: 6px; padding: 8px 12px; color: var(--c1-text); font-size: 13px; font-family: 'SFMono-Regular', Consolas, monospace; outline: none; transition: border-color .15s; }
.sec1-ip-input:focus { border-color: var(--c1-accent); }
.sec1-ip-add-btn { background: var(--c1-accent); border: none; border-radius: 6px; color: #fff; padding: 8px 14px; font-size: 13px; cursor: pointer; white-space: nowrap; }
.sec1-ip-add-btn:disabled { opacity: .4; cursor: not-allowed; }
.sec1-ip-row { display: flex; align-items: center; gap: 12px; padding: 8px 12px; border-bottom: 1px solid var(--c1-border); font-size: 13px; }
.sec1-ip-val { flex: 1; font-family: 'SFMono-Regular', Consolas, monospace; }
.sec1-ip-date { font-size: 11px; opacity: .5; }
.sec1-ip-del { background: none; border: none; cursor: pointer; color: rgba(239,68,68,.7); font-size: 14px; padding: 2px 6px; border-radius: 4px; }
.sec1-ip-del:hover { background: rgba(239,68,68,.1); color: #ef4444; }

/* Hide sliding panel — replaced by inline top-strip */
.c1-security-page .c1-panel { display: none !important; }

/* ── TEAM FEATURES ── */
.sec1-team-summary {
  display: flex; flex-wrap: wrap; gap: 8px;
  padding: 8px 0 12px;
}
.sec1-team-pill {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 5px 12px; border-radius: 20px;
  background: var(--c1-surface); border: 1px solid var(--c1-border);
  font-size: 12px; color: var(--c1-text);
}
.sec1-team-pill-dot {
  width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0;
}
.sec1-user-team-dot {
  display: inline-block; width: 7px; height: 7px; border-radius: 50%;
  margin-right: 4px; vertical-align: middle; flex-shrink: 0;
}
</style>
